module.exports = {
  PleaseChooseJob: '请选择订舱单。',
  NoSearchingInfo: '没有输入查询信息 。',
  NoRecordMeetTheConditions: '没有查询到符合要求的记录。',
  Error: '错误产生。',
  Locked: '已锁定',
  UnKnownStatus: '状态未知',
  CloseDetailWindow: '关闭详细窗口',
  AdvancedSearch: '高级查询',
  NoCustomersFoundPleaseRefreshCache: '客户不存在,请尝试重置缓存!',
  SelectedMonthHasBeenClosed: '当前选择的月份已关过帐。',
  AccountClosedSuccessfully: '关帐成功。',
  PleaseSelectClosingRecord: '请选择关帐记录。',
  ClosingRecordHasBeenApproved: '关帐记录已审核,无法取消.',
  CancelTheClosingRecord: '确定要取消关帐记录吗？',
  AccountClosingRecordCanceled: '已取消关帐记录',
  CannotBeCancelledAfterApproval: '审核后关帐记录无法取消，确定吗？',
  ClosingDateAfterCancelingTheApproval: '取消审核后可以取消关帐日期，确定吗？',
  BillingType: '开票类型',
  ByTicket: '票结',
  InvitationListTip: '客户已提交补料，再次邀请对单，将解锁客户的补料页面，并允许编辑后再次提交！是否继续？',
  PleaseClickFirst: '请先点击“确认对单”',
  PleaseSelectTheFeeYouNeedToPush: '请选择您需要同步的费用',
  PleaseSelectTheFeeYouNeedToCopy: '请选择您需要复制的费用',
  PleaseSeparateMultipleEmailAddressesWithCommas: '多个邮箱地址请以逗号隔开',
  PleaseSupplementOtherMailboxes: '请补充其他邮箱',
  ContactAndEmailAreNotMaintained: '未维护联系人和邮箱',
  PleaseSelectTheMaintainedContactAndMailbox: '请选择已维护的联系人以及邮箱',
  SelectMailbox: '选择邮箱',
  InvoiceUuidCannotBeBlank: '发票uuid不能为空',
  lackInvoiceConfirm: '当前付款申请缺少发票文件，是否确认继续提交？',
  TheSettlementUnitIDCannotBeEmpty: '结算单位id不能为空!',
  PleaseEnterYourEmailAddress: '请输入邮箱',
  Monthly: '月结',
  PleaseSelectTheDataYouWantToExport: '请勾选需要导出的数据',
  NoData: '没有数据',
  PleaseSelectJob: '请选中业务。',
  ThisJobIsNotWorkingCanNotBeEdited: '此单不是正操作状态, 不能被编辑',
  CanNotEditJob: '不能修改{0}的业务！',
  TheSameSalesAndOperationsConfirmThatYouWantToSave: '销售和操作相同,确认要保存吗?',
  SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt: '揽货类型与小票不相同，是否要保存?',
  WHNoRepeatedContinue: '进仓编号重复，是否继续？',
  Prompt: '提示',
  MblNoRepeatedContinue: 'MBL号码重复，是否确认保存？',
  MblNoRepeatedNotCurrentCompanyContinue: '您输入的单号不属于当前业务的操作分公司或者部门，请确认是否继续',
  MblNoRepeatedNotCurrentCompanyContinueAll: '您输入的MBL重复，并且不属于当前业务的操作分公司或者部门，请确认是否继续',
  MblNoSiRepeatedContinue: '主单号重复，是否确认保存？',
  MblNoRepeatedNotSave: 'MB/L NO.【{0}】重复不允许保存。',
  AlreadyAssociatedWithOtherBranches: '已有其他分公司关联【{0}】，请选择其他合作伙伴进行关联！',
  CustomerRefNoRepeatedContinue: '业务参考号重复，是否确认保存？',
  HblNoRepeatedContinue: 'HBL号码重复，是否确认保存？',
  SoNoRepeatedContinue: 'SoNo号码重复，是否确认保存？',
  HAWBRepeatedContinue: 'HAWB分单号不允许重复',
  HBLRepeatedContinue: 'HBL分单号不允许重复',
  IATACodeRepeat: 'IATA CODE不能重复',
  AirCodeRepeat: '航空公司不能重复',
  AuthenticationFailed: '验证失败!',
  SaveSuccessfully: '保存成功',
  InvoiceNoLength: '发票号超长，请检查',
  Success: '成功',
  ShutOutSuccessfully: '退关成功',
  CancellationSuccessfully: '作废成功',
  CancelShutOutSuccessfully: '取消退关成功',
  ThisTemplateCouldNotBeResolvedPleaseContactCS: '不能解析此模板，请联系客服。',
  CurrentBranchIsNotSelectedCannotAddNewBookings: '没有选择当前分公司，不能增加订舱单。',
  CompanySelectedIsHQCannotAddNewBookings: '公司选择为总公司，不能增加订舱单。',
  TheLastOfTheNewStateHasBeenRestored: '已恢复上次的新增状态。',
  CancelMotify: '取消当前修改？',
  Info: '信息',
  NoBusinessCanBeSplit: '没有业务可拆分。',
  SplittingErrorContainerInformationIsEmpty: '拆分错误，装箱信息为空。',
  IsNotOperationStatus: '不是正操作状态。',
  SureDelete: '确定删除吗？',
  DeleteSuccessfully: '删除成功',
  CustomerIssuing: '未勾选HBL 客户自出单， 请前往HBL 页签勾选',
  CustomerIssuingTips: '放单状态： 待收款/已扣单， 是否继续上传文件类型“客户自出单”？',
  DirectBusiness: '直单',
  SplittingBusiness: '分单',
  NoPermissionToEditTheJob: '您没有权限编辑本票。',
  HaveBusinessHasBeenSubmittedCannotBeShutOut: '选择的记录中包括有财务审核业务，请检查。',
  HaveBusinessHasBeenShutOuted: '选择的记录中包括有退关业务，请检查。',
  HaveBusinessHasBeenCancellation: '选择的记录中包括有作废业务，请检查。',
  PleaseRemoveThisTicketFromMblThenShutOutBatch: '请从主票移出选择的小票，然后退关。',
  PleaseRemoveAllTicketsFromMblThenShutOutBatch: '请从选择的主票移出所有小票，然后退关。',
  HasChargeToShutOutTip: '将会对有费用的业务进行有费用退关，是否确认?',
  NoneChargeToShutOutTip: '将会对无费用的业务进行无费用退关，是否确认?',
  BusinessHasBeenSubmittedCannotBeShutOut: '业务已提交财务审核，无法退关。',
  NoPermissionToCancelTheShutOut: '你没有取消退关的权限。',
  ConfirmToCancelTheShutOut: '确认取消退关吗？',
  Warning: '警告',
  NoChargeToShutOut: '无费用退关',
  HasChargeToShutOut: '有费用退关',
  PleaseConfirmTheShutOut: '请确认退关？',
  SendStatusChangeNotification: '发送状态变更通知',
  StatusChangeNotification: '状态变更通知(内部人员)',
  OptionIsChecked: '如果勾选此选项,会触发对内对外SOP变更通知邮件',
  OnlyBeUsedForChangingCosts: '只可作费用相关更改',
  DoNotMakeAnyChanges: '不可作任何更改(所有费用会被删除)',
  IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut: '如果不清除已确认费用，不可无费用退关。',
  PleaseRemoveThisTicketFromMblThenShutOut: '请从主票移出这一小票,然后退关.',
  PleaseRemoveAllTicketsFromMblThenShutOut: '请从这一主票移出所有小票, 然后退关.',
  TicketsMustBeVoted: '小票必须加入主票',
  NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance: '应付费用没有全部审核无法预提交.',
  CommitSuccessfully: '提交成功。',
  LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL: '拼箱小票无法单独提交，请提交主票.',
  GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice: '是否根据当前卖价、买价生成费用?',
  PlatformCodeNotFound: '收费项目中未找到平台代码为A/F的空运费',
  Withdraw: '撤回',
  AlreadyReturn: '已退回。',
  AlreadyWithdraw: '已撤回。',
  ReturnAction: '退回操作',
  IsConfirm: '是否确认',
  Return: '退回',
  BatchReturnSucceeded: '批量退回成功:{0}',
  BatchReturnPreSubmitCheck: '只允许退回业务状态为预提交的单子。',
  BatchReturnSubmitCheck: '只允许撤回业务状态为已提交的单子。',
  BusinessIsNotCommittedAndCannotBeWithdrawn: '业务非【已提交】状态，不可撤回',
  BusinessIsNotPreCommittedAndCannotBeReturn: '业务非【预提交】状态，不可退回',
  BatchUnlockLockedBillsOfAccountsReceivable: '只能批量解锁应收费用已锁定的单子！',
  lowBalanceTips: '您识别报关单余额不足，无法识别所有的批量上传报关单文件<br/>1) 选择继续上传文件到文件历史，但不识别报关单信息<br/>2) 选择充值后再上传，则默认不上传文件且不解析报关单',
  lowBalanceTips1: '继续上传文件',
  lowBalanceTips2: '充值后再上传',
  BatchUnlockLockingBillsOfAccountsReceivable: '只能批量锁定应收费用已解锁的单子！',
  BatchUnlockLockingBillsOfAccountsPayable: '只能批量锁定应付费用已解锁的单子！',
  BatchUnlockLockedBillsOfAccountsPayable: '只能批量解锁应付费用已锁定的单子！',
  UnlockChargeStatus: '确认是否解锁{0}费用状态?',
  LockingChargeStatus: '确认是否锁定{0}费用状态?',
  SuccessfullyUnlockedFeesInBatch: '批量解锁{0}费用成功:{1}',
  SuccessfullylockingedFeesInBatch: '批量锁定{0}费用成功:{1}',
  ThereAreFeesReceivableNotInvoicedPrint: '有应收费用未开发票，确定要打印吗?',
  ThereAreFeesReceivableNotInvoicedSubmit: '有应收费用未开发票，确定要提交吗?',
  VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: '本单业务将提交财务审核，提交前请确认相关文件已经上传系统，是否继续?',
  SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: '本单业务将提交上级审核，提交前请确认相关文件已经上传系统，是否继续?',
  PleaseInputTheSalesInformationAndPrints: '请录入销售人员信息再打印!',
  PleaseInputTheSalesInformationAndSubmit: '请录入销售人员信息再提交!',
  FollowingTheSingleDidNotEnterTheSalesInformation: '以下几单没有输入销售人员信息',
  PleaseEnterAndPrint: '请输入后再打印!',
  PleaseSelectAWaterBillRecord: '请选择水单记录。',
  PleaseEnterAndSubmit: '请输入后再提交！',
  WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable: '有国外费用没有有效账单号，不能打印利润分析表!',
  WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted: '有国外费用没有有效账单号，不能提交!',
  BulkSubmissionOfWrittenSubmissionsOnlyList: '只能批量提交已经预提交的单子!',
  BulkSubmissionOfWrittenPreSubmissionsOnlyList: '只能批量预提交正操作状态的单子!',
  MakeSureToSubmitAListOftheNFinancialAuditPlease1: '确认要将这',
  MakeSureToSubmitAListOftheNFinancialAuditPlease12: '票单子提交财务审核吗？',
  BatchSubmittedSuccessfully: '批量提交成功',
  BatchSubmittedPreSuccessfully: '批量预提交成功',
  TheSelectedDocumentInconsistentNatureOfTheBooking: '所选单据约价性质不一致',
  TheSelectedDocumentIsNotTheSameVoyage: '所选单据不是同一个航次/船名',
  SelectTheData: '请选择数据',
  NoSelectedDataOrAreNotOperationalStatus: '数据未选择或不是正操作状态',
  TheSelectedServicesIncludeLockedServices: '勾选的业务里有已锁定的业务',
  SureYouWantToRemoveTheCharge: '确定要删除费用吗？',
  NoCostToRemove: '没有费用可删除。',
  NoBusinessOrIsNotOperationalState: '未选择业务或不是正操作状态。',
  MakeSureToDelegateTheBusiness: '确定要委托该票业务吗？',
  ErrorReadingInformation: '读取信息出错.',
  OrderTypeChangeTip: '切换订单类型后，部分已填写的数据将清除，是否确认切换?',
  BusinessDateCanNotNull: '业务日期不能为空',
  TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners: '接收方未在合作伙伴中维护当前公司信息',
  ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain: '该笔业务已经发送过电子委托，是否再次发送?',
  DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize: '没有找到对应的模板类型【BOOKING】和模板名称【海运出口货运委托书】，是否继续委托？',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: '当前订舱代理所属分公司没有在合作伙伴中维护对应本公司的合作伙伴',
  TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: '当前发运代理所属分公司没有在合作伙伴中维护对应本公司的合作伙伴',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI: '当前目的港代理所属分公司没有在合作伙伴中维护对应本公司的合作伙伴',
  TheBranchCompanyOfUnExchangeAgent: '当前换单代理所属分公司没有在合作伙伴中维护对应本公司的合作伙伴',
  TheBranchCompanyOfUnOurCompany: '当前运输公司所属分公司没有在合作伙伴中维护对应本公司的合作伙伴',
  TheOppositeSideHasScceptedNoNeedToReCommission: '对方已受理，无需再次委托!',
  SuccessfullySent: '发送成功.',
  NoSendingGoodsInfo: '不存在需要发送的货物信息.',
  NoAssociatedBusiness: '没有关联业务!',
  NoAssociatedContainerInfo: '没有可发送的装箱信息',
  PleaseEnterFleetInformatio: '请输入车队信息',
  ThisBoxIsNotAllowedToBeDeleted: '此箱子不允许删除',
  FailedToQueryTheAssociatedBusiness: '没有查询到关联业务.',
  RepeatedWarehouseNo: '进仓编号重复',
  NoStorageInfo: '没有入库信息',
  TheJobIsIncorrectPleaseRefreshThePageOrContactTheAdministrator: '工作单不正确，请刷新页面或联系管理员!',
  ConsignationCompanyCannotBeNull: '委托单位不能为空',
  FLCLTypeCannotBeNull: '整拼类型不能为空',
  POLCannotBeNull: '起运港不能为空',
  IfThereIsATransferTheTransferPortCannotBeNull: '如果有中转,中转港不能为空',
  PortOfDischargeCannotBeNull: '卸货港不能为空',
  PortOfDestinationCannotBeNull: '目的港不能为空',
  SalesCannotBeNull: '销售不能为空',
  SalesBranchCompanyIsNullPleaseReSelectSales: '销售分公司为空,请重新选择销售!',
  SalesDepartmentIsNullPleaseReSelectSales: '请选择销售部门!',
  DateOfDepartureCannotBeLaterThanDateOfArrival: '开航日期不能晚于到港日期',
  NominatedAgentCannotBeNull: '指定货代理不能为空!',
  FLCLTypeCannotBeNull2: '装拼类型不能为空!',
  ItemNoCannotBeNull: '项目编号不能为空!',
  EQSizeCannotBeNull: '箱型不能为空!',
  EQSizeCannotBeNull2: '至少存在一个箱子!',
  DearYouCanOnlySelectYourOwnCustomers: '亲，你只能选择自己的客户哦.',
  DepartmentCannotBeNull: '部门不能为空.',
  CyCutoffDateCannotBeLaterThanDepartureDate: '截关日期不能大于开航日期',
  BargeCutoffDateCannotBeLaterThanCyCutoffDate: '驳船截关日期不能大于截关日期!',
  ContainerSealInfoHasBeenEnteredCannotBeDeleted: '已输入相关的箱封信息,不能删除.',
  RelevantInstallationInfoHasBeenEnteredCannotBeDeleted: '已输入相关的装板信息,不能删除.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated: '计费重量发生更改，是否刷新原有按计费重量为单位的费用? 已经做账单、开票的费用不会更新。',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2: '计费重量发生更改，是否刷新原有按计费重量为单位的费用? 已经做账单、开票、付款申请、销账的费用不会更新',
  CurrencyChangeConfirm: '买价/卖价币种发生更改，是否刷新原有费用? 已经做账单、开票、付款申请、销账的费用不会更新',
  PriceTypeChangeConfirm: '买价/卖价类型发生更改，是否刷新原有费用? 已经做账单、开票、付款申请、销账的费用不会更新',
  PriceUpdateConfirm: '买价/卖价发生更改，确定更新买卖价按计费重量为单位的费用？已经做账单、开票、付款申请、销账的费用不会更新 ',
  TheChargedWeightHasBeenChanged: '计费重量发生更改，是否刷新原有按计费重量为单位的费用?',
  WeightChangeToRefreshCostBasedOnWeightPrice: '重量发生更改，是否刷新原有按重量价为单位的费用? 已经做账单、开票、付款申请、销账、关联提单的费用不会更新',
  WeightChangeToRefreshCostBasedOnWeightTonPrice: '重量发生更改，是否刷新原有按重量价(吨)为单位的费用? 已经做账单、开票、付款申请、销账、关联提单的费用不会更新',
  CubageChangeToRefreshCostBasedOnCubagePrice: '体积发生更改，是否刷新原有按体积价为单位的费用? 已经做账单、开票、付款申请、销账、关联提单的费用不会更新',
  InsideQuantityChangeToRefreshCostBasedOnCubagePrice: '小件数发生更改，是否刷新原有按小件数价为单位的费用? 已经做账单、开票、付款申请、销账、关联提单的费用不会更新',
  ChangeToRefreshCostBasedOnCubagePrice: '小件件数、毛重、体积、计费重量中发生更改，是否刷新原有按小件数、重量价、体积价、计费重量价为单位的费用? 已经做账单、开票、付款申请、销账、关联提单的费用不会更新',
  DistributedSuccessfully: '配货成功',
  BusinessReferenceNoReduplicated: '业务参考号重复',
  BookingAgentCannotBeNull: '订舱代理不能为空',
  DateOfDepartureCannotBeNull: '开航日期不能为空',
  TheMainInterfaceDoesNotExist: '主界面不存在',
  FeesHaveBeenUsedForThisUnit: '已有费用使用到该单位，请先调整相关费用的单位后再删除！',
  TheChargingUnitIsUsedByAnExistingChargePlan: '已有费用方案使用到该计费单位，请先调整相关费用方案的单位后再删除',
  TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst: '拼箱主单业务编号还未生成, 请先保存主票.',
  TheSubBillHasBeenConsolidatedAndCannotBeRemoved: '该小票已拼过箱，不能移出。',
  PleaseSelectSubBills: '请选择小票.',
  PleaseSaveTheChangedDataOrExitTheEditStateAndThenCloseTheModule: '请先保存更改的数据,或退出编辑状态,然后关闭模块.',
  replaceInvoiceRemarkRequired: '请输入替票说明',
  MblNoIsNull: 'MB/L No为空',
  SONoIsNull: 'S/O No为空',
  NoVesselVoyageInformation: '没有船名航次信息',
  ObtainSuccessfully: '获取成功',
  PleaseSelectCopyType: '请选择抄录类型.',
  NoTargetShippingCompanyFoundHerePleaseRefreshTheCache: '没有找到此船公司,请刷新缓存!',
  BlIsConfirmed: '提单已经确认.',
  ThisHblIsCombinedAndCannotBeEdited1: '该票HBL已被并入',
  ThisHblIsCombinedAndCannotBeEdited2: '不可编辑.',
  ToOrederBlCannotBeTelexReleased: 'TO ORDER不可进行电放',
  PleaseInputBlSerialNumberFirst: '请先输入提单流水号！',
  PleaseSelectTheListToBeMergedInto: '请选择需要并入的单子!',
  PleaseInputBussinessNo: '请输入业务编号!',
  NoSelectedContainerInformation: '未勾选装箱信息.',
  PleaseSelectData: '请勾选数据',
  OnlySelectOneData: '只能勾选一条数据',
  Count: '票数',
  AreYouSureYouWantToRemoveTheSubBill: '确认要移出小票吗？',
  RemovedSuccesfully: '移除成功.',
  NoSubBillsToSplit: '没有可拆分的小票.',
  SoNoCannotBeNull: '关单号(S/O)不能为空.',
  CancelTheCurrentQuery: '取消当前查询？',
  SelectTheOrderYouWantToJoin: '请选择要加入的订舱单.',
  HasJoinIntoMbl: '已经加入到主票中.',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue: '新选小票的船名、航次、承运人、订舱代理、目的港代理、ETD、ETA、仓库信息与主票不一致。系统将修改小票。是否继续？',
  ContainerNoDoesNotComplyWithTheNumberingRules: '箱号不符合编号规则.',
  SealNoHasBeenChanged: '封号已更改过.',
  PleaseSelectTheDesiredPrintVgm: '请选择需要打印的VGM.',
  DeleteTheVgmInformation: '您要删除该VGM信息吗？',
  PleaseEnterEnglish: '请输入英文.',
  PleaseEnterTheShippingCompanyInformation: '有运输费用，请输入运输公司信息!',
  SameJobtruckOrderNo: '门对门装箱派车单号存在重复，请修改!',
  SureYouRemoveThisNData1: '确定删除这',
  SureYouRemoveThisNData2: '条数据吗？',
  AreYouSureYouWantToSendACarOrder: '您确定要发送派车单吗？',
  AreYouSureYouWantToModifyACarOrder: '您确定要更改派车单吗？',
  AreYouSureYouWantToRevokeACarOrder: '您确定要撤单吗？',
  ThisCarOrderIsSended: '派单成功之后，不可以再次派单，只能通过改单进行修改请求。',
  ThisCarOrderCanOnlyBeModifiedAfterSending: '派单之后才可以进行改单操作。',
  ThisCarOrderIsSendedNoAddUsage: '一票派车单派车成功之后，不允许再添加柜子。',
  ThisCarOrderCanOnlyBeRevokedIsUnApproved: '只有未接单状态才可以撤单。',
  ThisCarOrderIsChanged: '提示：回执数据有更改',
  DeleteFailed: '删除失败',
  Failure: '失败',
  DispatchSuccess: '派单成功',
  ModifiedTruckOrderSuccess: '改单成功',
  RevokeTruckOrderSuccess: '撤单成功',
  DispatchFailed: '派单有异常',
  ModefiedTruckOrderFaild: '改单有异常',
  RevokeTruckOrderFaild: '撤单有异常',
  VgmWeightingMethod: 'VGM称重方式',
  LdpWarn: '冷冻品时至少有一行同时必填',
  WxpWarn: '危险品时至少有一行同时必填',
  Transfer: '船代换船',
  ReasonForDeletion: '删单原因',
  ReasonForDeletionNotEmpty: '删单原因不能为空',
  VesselRegex: '必须为大小写字符和数字，不能超过35个字符',
  BlNumberRegex: '只允许数字',
  DanClass: '必须在1-9.9之间',
  CubageRegex: '范围必须在0.001-2000.999之间',
  RowPrefix: '关单号{0}的',
  UpdateVesselVoyNo: '修改船名航次',
  UpdateVesselVoyNoError: '未发送成功的舱单无法修改船名航次',
  InputVesselVoyNo: '请填写更新后的船名航次',
  ShipNotRegistered: '船舶未备案',
  LoadManifest: '装载舱单',
  ModificationFailed2: '改配失败',
  ModifiedSuccessfully: '改配成功',
  NoDelete: '没有可以发送删除舱单的数据',
  SendFailed: '发送失败',
  SaveFailed: '保存失败',
  ViewWarehouseEntryPhotos: '查看进仓照片',
  DistributeFailedNoFoundRelatedStorageRecord: '配货失败，没有找到对应的仓储记录!',
  SureYouWantToCancelTheBindingToTheStorageData: '确认要解除与仓储数据的绑定吗？',
  QueryFailed: '查询失败',
  SelectDeclarations: '请选择报关单.',
  SelectCustomsInformation: '请选择报关信息.',
  SelectCustomsRecord: '请选择报关记录.',
  TheNumberOfTenBitCodeYouEnteredIsNotEnough: '啊哦，您输入的十位码位数不足.',
  OperatingCompanyCannotBeNull: '经营单位不能为空.',
  DateOfCustomsDeclarationCannotBeNull: '报关日期不能为空.',
  PleaseSelectStatusOfCustomsDeclaration: '请选择报关状态.',
  CargoDetailsWEIGHTBannotBeNull: '货物明细-WEIGHT不能为空',
  ReleaseTypeBeNull: '提单方式不能为空',
  CargoDetailsAMOUNTBannotBeNull: '货物明细-AMOUNT不能为空',
  CargoDetailsCustomsDutyRateBannotBeNull: '货物明细-关税税率不能为空',
  CargoDetailsCustomsDutiesBannotBeNull: '货物明细-关税不能为空',
  CargoDetailsIncrementRateCannotBeNull: '货物明细-增值税税率不能为空',
  CargoDetailsIncrementValueDutyBannotBeNull: '货物明细-增值税不能为空',
  CargoDetailsConsumptionDutyRateBannotBeNull: '货物明细-消费税税率不能为空',
  CargoDetailsConsumptionDutyBannotBeNull: '货物明细-消费税不能为空',
  CargoDetailsCurrencyBannotBeNull: '货物明细-币种不能为空',
  CargoDetailsExchangeBannotBeNull: '货物明细-汇率不能为空',
  CargoDetailsCargoPriceBannotBeNull: '货物明细-货价不能为空',
  CargoDetailsTaxBannotBeNull: '货物明细-税金不能为空',
  CargoDetailsTaxRateBannotBeNull: '货物明细-税率不能为空',
  ImportSuccessful1: '导入成功',
  ImportSuccessful2: '条',
  ImportFailed: '导入失败',
  CargoDetailsIsNotSelected: '未选择货物明细.',
  PleaseSelectUnRelatedTradeDetailData: '请选择未关联的货物信息',
  SelectTheBillingObject: '选择结算对象',
  NoChargeForTheSettlementOfDomesticObjects: '没有费用为国内的结算对象.',
  CancelAudit: '取消审核',
  ChargesAudit: '费用审核',
  ThereAreFeesCantBeDeletedPleaseRecheck: '包含不可删除的费用，请核对.',
  TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended: '费用已财务结算，不能修改.',
  RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment: '红冲费用或者被红冲费用不能再次修改调整，请选择增加调整.',
  RedChargeOrRedChargedCannotBeDeletedPleaseReselect: '红冲费用或者被红冲费用不能被删除，请重新选择.',
  PleaseRefresh: '费用已被他人修改，请刷新',
  ChargeItemCannotBeNull: '费用名称不能为空！',
  MeasureCannotBeNull: '费用单位不能为空！',
  SettlementPartyCannotBeNull: '结算对象不能为空！',
  CurrencyCannotBeNull: '币种不能为空！',
  AmountCannotBeNull: '数量不能为空！',
  UnitRateCannotBeNull: '单价不能为空！',
  CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd: '订舱未勾选报关服务,无法新增：',
  WaerhouseServiceIsNotSelectedInBookingCannotAdd: '订舱未勾选仓储服务,无法新增：',
  HaulageServiceIsNotSelectedInBookingCannotAdd: '订舱未勾选运输服务,无法新增：',
  ChargeIsNotSelectedOrAllChargesSubmit: '未选择费用或已全部提交.',
  ChargeIsNotSelectedOrNotInTheSubmissionStatus: '未选择费用或不是提交状态.',
  OperationSuccessfully: '操作成功',
  PayablesIsNull: '应付费用为空.',
  ReceivalbeIsNull: '应收费用为空.',
  CopyThePayablesSuccessfullyTotallyOfNItems1: '抄录应付费用成功，共产生',
  CopyThePayablesSuccessfullyTotallyOfNItems2: '笔费用',
  CopyTheReceivablesSuccessfullyTotallyOfNItems1: '抄录应收费用成功，共产生',
  CopyTheReceivablesSuccessfullyTotallyOfNItems2: '笔费用',
  NoPayablesCanBeCopiedThereMayBeSameChargeItems: '没有应付费用可抄录，可能存在相同费用名称.',
  NoReceivablesCanBeCopiedThereMayBeSameChargeItems: '没有应收费用可抄录，可能存在相同费用名称.',
  CopyChargeSuccessfullyTotallyOfNItems1: '抄录费用成功，共产生',
  NoChargeCanBeCopiedThereMayBeSameChargeItems: '没有费用可抄录，可能存在相同费用名称.',
  TheCurrentlyRelevantBusinessInformationIsNull: '当前关联的业务信息为空.',
  PleaseSelectCharges: '请选择费用',
  SelectChargesAreInControl: '已受控选中费用',
  SelectedChargesAreCancelledControlling: '已取消受控选中费用',
  PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails: '请去整箱运价查询模块查看运价详情！',
  PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails: '请去空运运价查询模块查看运价详情！',
  DoYouNeedToInviteOthersToConfirmTheCharges: '您需要邀请确认费用吗？',
  TheMailHasBeenSentPleaseNoteAndHaveACheck: '邮件已发送，请注意查询!',
  PleaseSelectReceivableCharges: '请选择一条应收费用',
  PleaseSelectPayableCharges: '请选择一条应付费用',
  OnlyAuditChargesHaveBeenSubmitted: '只能审核已提交的费用',
  NoChargesToAudit: '没有需要审核的费用，请检查费用审核人或费用状态',
  NoChargesToUnAudit: '没有需要取消审核的费用，请检查费用审核人或费用状态',
  NoChargesToReject: '没有需要驳回的费用，请检查费用审核人或费用状态',
  YouAreNotACostSpecifiedByTheReviewerCannotAuditTheCharges: '请确保您是所有费用的审核人',
  SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill: '所选费用中包含全部核销的费用，是否将其加入账单？',
  AllSelectedFeesWillBeVerifiedPleaseChooseAgain: '所选费用均以全部核销，请重新选择',
  IncludeFullyWrittenOffCosts: '所选费用中包含全部核销的费用，是否将其加入发票？',
  AuditSuccessfully: '审核成功',
  CancelSuccessfully: '取消成功',
  PleaseSelect1ChargeDetail: '请选择费用明细 .',
  NoPriceToMeetTheQueryCriteria: '没有查询到符合条件的价格.',
  Prepaid: '预付',
  Collect: '到付',
  PrePayTheSamePrice: '预到付同价',
  RefreshRateFailed: '运价刷新失败!',
  PleaseSelectThePrice: '请选择价格！',
  Invalidation: '失效',
  Normal: '正常',
  suspension: '停航',
  NoPickingUp: '不接',
  Inquiry: '询价',
  Tension: '紧张',
  OverStowage: '爆舱',
  CreateBill: '按费用币种分别建账单',
  SplitBill: '按原币别拆分生成账单',
  PleaseBeNotedThatThisRateIsUnderSuspendSailing: '请注意运价处于停航状态！',
  PleaseBeNotedThatThisRateIsUnavailableNow: '请注意运价处于不接状态！',
  PleaseBeNotedThatThisRateIsOnlyForPartOfEQType: '请注意此运价部分箱型不接！',
  PleaseBeNotedThatThisRateIsUnderOverbookedStatus: '请注意运价处于爆仓状态！',
  TheOriginOfSelectedRateIsDifferentFromBookingAgent: '选中价格运价来源与工作单的订舱代理不相同',
  Unconfirmed: '未确认',
  Confirmed: '已确认',
  Receivable: '应收',
  Payable: '应付',
  Bill: '账单',
  TheBillDoesNotConfirm: '账单未确认',
  SureYouWantToCancel: '确定要取消吗?',
  StateModifiedSuccessfully: '状态修改成功.',
  NoInternalCostsToBilling: '没有国内费用可开账单',
  NoSettlementUnit: '没有结算单位.',
  CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip: '结算对象为空,不能新增费用确认单.',
  ClearingUpInvoicingInformationWasNotSuccessfullyRead: '结算对象开票抬头信息未成功读取.',
  YouDontHavePermissionToEditBills: '你没有编辑应付账单的权限.',
  YouDontHavePermissionToDeleteBills: '你没有删除应付账单的权限.',
  HaveNoPermissionToDeleteBillsCreatedByOtherUsers: '无权限删除其他用户创建的账单',
  NoSelectedBill: '未选择账单.',
  ClearingTheObjectDoesNotExistPleaseTryResettingTheCache: '结算对象不存在，请重置缓存试试.',
  BillSaveSuccessfully: '账单保存成功',
  BillingObjectIsNull: '账单对象为空.',
  ChargeCannotBeEmpty: '费用不能为空.',
  TaxesAndTaxRatesDoesNotMatchTheData: '税额和税率数据不符.',
  InvoicingHeadCannotBeEmpty: '开票抬头不能为空',
  CurrencyExchangeRateIsNotMaintained1: '币种',
  CurrencyExchangeRateIsNotMaintained2: '汇率未维护.',
  FeeCurrencyMustBeTheSame: '费用币种必须相同.',
  NoForeignFeeBilling: '没有国外费用可开账单.',
  ThisJobIsNotWorkingCanNotBeDeleted: '此单不是正操作状态, 不能删除。',
  SureYouWantToDeleteTheBilling: '确定删除该账单?',
  SureAuditTheBill: '确定审核该账单吗？',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided: '此账单已提交财务审核,不能被作废.',
  ThisOrderHasBeenRevokedNotARepeatedAction: '此单已作废,不能重复操作.',
  DomesticBillsCannotBeVoided: '国内账单不可作废',
  TheBillHasBeenConfirmedAndCannotBeVoided: '账单已确认，不可作废 <br/> 如需作废请先取消确认',
  ThisVerificationHasBeenDoneAndCannotBeVoided: '此单已做过核销,不能被作废.',
  AccountIsClosedAnyOperationIsNotAllowed: '已经关账，不允许任何操作',
  ThisFormIsLockedAndCannotBeVoided: '此单已被锁定,不能被作废',
  ThisFormIsLockedAndBillingGroup: '此单存在对账单,不能被作废',
  ConfirmTheCancellationOfTheBill: '确定作废该账单？',
  ConfirmTheCancellationOfTheBill2: '确认作废已选择的账单吗？',
  TheBillHasBeenRevoked: '账单已作废.',
  NoSelectSettlement: '结算对象未选择.',
  BillOfExchangeCannotBeEmpty: '账单汇率不能为空',
  CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether: '代收垫付和普通费用不能合在一起开账单.',
  TheBillNumberIsCreatedSuccessfully: '账单号创建成功',
  TheWordCorrespondingNetworkNameOrTheOverseasAgentNetworkManagementCodeHasNotBeenMaintained: '海外代理对应的网管名字或网管两字代码尚未维护,不能生成账单号!',
  EnterTheShareProportion: '请输入分成比例.',
  PleaseSelectACurrency: '请选择币种.',
  PleaseEnterTheBillingObject: '请输入结算对象.',
  PleaseAddCosts: '请添加费用.',
  TheAmountOfBillCannotBeEqualTo: '账单金额不能等于0',
  PleaseEnterTheNameOfTheCosts: '请输入费用名称.',
  PleaseEnterTheQuantityOfTheCosts: '请输入费用数量.',
  PleaseEnterThePriceOfTheCosts: '请输入费用单价.',
  PleaseSelectTheCostToRemove: '请选择要删除的费用.',
  CollectingInconsistentWithTheTotalAdvance: '代收与垫付总额不一致!',
  TheBillHasBeenInvoicedAndCannotBeDeleted: '该账单已经开票，不能删除',
  LoadFailed: '加载失败',
  PlatformCodeAlreadyExists: '平台代码已存在！',
  NameCannotBeRepeated: '收付费科目的中文名称或者英文名称不能重复!!!',
  ChineseNameCannotBeBlank: '收付费科目的中文名称不能为空!!!',
  CannotBeModified: '已被业务使用，不能修改其名称',
  PleaseSelectAServiceItem: '请选择服务项',
  Overseas: '国外',
  Domestic: '国内',
  PleaseSelectTheDesiredPrintInformation: '请选择需要打印的信息',
  ThereIsAnErrorReadingWriteOffInformation: '核销单信息读取出错',
  TheBookingDoesNotExistAndCannotBeAdded: '订舱单不存在，不能新增。',
  PleaseEnter: '请至少输入两个字符后开始查询',
  PleaseEnterTheCode: '请输入代码、名称等模糊查询...',
  PleaseEnterTheCode2: '请输入(至少两个字符)代码、名称等模糊查询...',
  PleaseEnterTheContent: '请输入内容',
  PleaseSelectDataBeforeOperation: '请选择数据后操作',
  NoPortRecordMeeting: '未选择符合要求的港口记录，请重新选择！',
  DeleteTheSelectedRecord: '是否对选择的记录进行删除',
  DoYouConfirmThatYouWantToDelete: '你确认要删除吗?',
  DeletionCancelled: '已取消删除',
  EditCancelled: '已取消编辑',
  PleaseSelectARecordToEdit: '请选择一条记录进行编辑',
  PleaseFillInTheCorrectFiveDigitPortCode: ' 请填写正确的港口五位代码. ',
  DeleteFail: '删除失败!',
  DeleteSucceeded: '删除成功!',
  DisplayRuleCannotBeEmpty: '显示规则不能为空!',
  OperationRequirementsCannotBeEmpty: '操作要求不能为空!',
  OperationRequirementsCannotBeGreaterThan: '操作要求长度不能大于2048位!',
  NewPortRequestSucceeded: '新增港口要求成功',
  EditPortRequestSucceeded: '修改港口要求成功',
  ConfirmDelete: '删除确认',
  IsItUsedForMAWB: '是否用于MAWB',
  IsItUsedForHAWB: '是否用于HAWB',
  AddPortRequirementsAirport: '添加港口要求（空港）',
  EditPortRequirementsAirport: '编辑港口要求（空港）',
  PleaseSelectARecordToDelete: '请选择记录进行删除',
  BackPageTip: '【返回上一页】后将删除在投保页面填写的信息，确认要返回吗？',
  WarmReminder: '温馨提示',
  GoBack: '返回上一页',
  ReturnToHomepage: '返回首页',
  HomepageNotSupportImport: '货运险首页暂不支持直接导入投保',
  PortInformationEditedSuccessfully: '编辑港口信息成功',
  AirlineInformationEditedSuccessfully: '编辑航空公司信息成功',
  SuccessfullyAddedAirlineInformation: '添加航空公司信息成功',
  SuccessfullyAddedPortInformation: '添加港口信息成功',
  GetBack: '取回',
  FailedToInquiryCustomsDeclarationInformation: '查询报关信息失败：',
  PleaseSelectARecord: '请选择记录.',
  NewDocuments: '新建单证',
  EditDocuments: '编辑单证',
  FileTypeCannotBeEmpty: '文件类型不能为空!',
  FileNumberCannotBeEmpty: '文件编号不能为空',
  FileNumberAlreadyExists: '文件编号已存在.',
  DataEnabledSuccessfully: '数据启用成功。',
  DataDisabledSuccessfully: '数据禁用成功。',
  Error2: '错误',
  TheDocumentHasBeenSaved: '单证已经保存',
  TheCustomsBrokerCannotBeEmpty: '报关行不能为空.',
  NoInformationCanBeQueried: '没有报关信息可查询.',
  ErrorSavingBusinessState: '保存业务状态错误',
  OrderInformationWasSuccessfullyUpdated: '订单信息更新成功.',
  NoExternalUpdateInformation: '没有外部更新信息',
  ExternalInformationWasSuccessfullyUpdated: '外部信息更新成功',
  NodeStatusIsNotPreserved: '节点状态未保存.',
  TheNodeAffinityForTheMailTemplateIsNotMaintained: '节点关联邮件模板未维护.',
  DoNotLocateAnAssociatedPrintTemplateType: '未找到关联的打印模板类型.',
  TheEmailWasSentPleaseNoteTheQuery: '邮件已发送，请注意查询!',
  PleaseSelectAFile: '请选择文件！',
  SureYouWantToDeleteFiles: '确定要删除文件吗？',
  EmailAddressCannotBeEmpty: '邮件地址不能为空.',
  UploadSuccess: '上传成功:',
  UploadFailed: '上传失败:',
  FileSizeExceedsMBYouCannotUpload: '个文件体积超过20MB,不能进行上传.',
  DoNotSelectedCategory: '未选择文件类别.',
  PleaseSelectAJob: '请选择工作单.',
  PleaseSelectTheSameTypeOfJob: '请选择同一类型的工作单',
  NotStart: '未开始',
  PleaseSelectABusinessStatus: '请选择业务状态',
  PleaseSelectABusinessStatusDetails: '请选择业务状态明细',
  EditedSuccessfully: '修改成功',
  PleaseContactTheSuperiorUnlocked: '由于信控超出,本票已被锁定不能打印,请联系上级解锁!',
  CanSuccessfullyPrint: '是否已经成功打印？',
  ConfirmToPrint: '打印确认',
  CorrespondsToThePrintTemplateDoesNotFind: '没有找到对应的打印模板',
  FailedToGetTheTemplateType: '获取模板类型失败!',
  NoSelectedTemplate: '未选择模板.',
  BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow: '批量转船成功，是否要关闭弹出窗口',
  BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow: '批量转车成功，是否要关闭弹出窗口',
  NoFeesCanBeDeleted: '没有费用可删除.',
  NoSelectedCharge: '未选择费用.',
  NoChargeCanBeSaved: '没有可保存的费用.',
  ChargeNameCannotBeEmpty: '费用名称不能为空.',
  ClearingTheObjectCannotBeNull: '结算对象不能为空.',
  BusinessNumberIs0: '业务编号的数量为0.',
  CustomerIsNULL: '客户为空',
  TheCarrierIsEmpty: '承运人为空,',
  AgentIsNULL: '订舱代理/换单代理为空,',
  AgentIsNULL2: '海外代理/目的港代理为空,',
  CustomsIsNull: '报关行为空,',
  TerminalCompanyIsNull: '码头公司为空,',
  TheObjectCannotBeUsedAsTheDefaultSettlement: '不能作为默认结算对象.',
  AddSuccessfully: '新增成功.',
  DisplaysTheCostOfUpdatingResults: '显示费用更新结果',
  TotalCost1: '共',
  TotalCost2: '条费用,',
  Updated1: '更新了',
  Updated2: '条,',
  NotUpdated1: '还有',
  NotUpdated2: '条未更新.',
  NotMatchingTheCostOfTheProjectCanBeAdded: '<i class="el-icon-info" style="font-size: 16px;"></i><span style="font-size: 14px;margin-left: 5px;">没有匹配的费用项目</span><b style="font-size: 16px;">可新增</b>',
  ChargeWasSuccessfullyUpdated: '费用更新成功.',
  NotMatchingTheCostOfTheProjectCanBeUpdated: '没有匹配的费用项目可更新.',
  NoAddedCharge: '未新增费用.',
  DefaultValuesAreSavedSuccessfully: '默认值保存成功.',
  ContSigned: '(已签约)',
  ContUnsigned: '(未签约)',
  InvalidCont: '(合约失效)',
  TheSystemHasBeenUpdatedPleaseRefreshThePage: '系统已经更新，请刷新页面！',
  PleaseInputCosts: '请输入费用项.',
  SelectTheSurchargeClause: '请选择附加费条款.',
  HAWBCannotBeNull: 'AMS分单号不能为空!',
  ENSHblNbr2CannotBeNull: 'ENS分单号不能为空!',
  HAWBAfrCannotBeNull: 'HB/L编号不能为空!',
  HAWBCannotBeRepeated: 'AMS分单号不能重复!',
  HAWBAfrCannotBeRepeated: 'HB/L编号不能重复!',
  InlandCannotBeNull: '内陆点/仓库不能为空!',
  rocordNumberCannotBeNull: '加拿大海关备案号不能为空!',
  AreYouSureYouWantToDelete1: '你确定要删除',
  SureDeleteHbl: '分单删除后无法恢复，确认删除？',
  AreYouSureYouWantToDelete2: '吗？',
  PleaseSelectTheAMSNO: '请先选择AMS编号',
  PleaseSelectTheHBLNO: '请先选择HB/L编号',
  TheMaximumCannotExceedLines: '最大不能超过5行!',
  DisplayColumn: '自定义显示列',
  Display: '可见',
  Name: '列名',
  TradeCommissionedUnitCannotBeEmpty: '贸易-委托单位不能为空',
  TradeSalesSupportCannotBeEmpty: '贸易-销售支持不能为空',
  TradingCurrencyCannotBeEmpty: '贸易-订单币种不能为空',
  TradingExchangeRateCannotBeEmpty: '贸易-订单汇率不能为空',
  TradeServiceFeeDiscountRateCannotBeEmpty: '贸易-服务费折扣率不能为空',
  TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders: '贸易-订单核销金额不能大于订单金额',
  TradePaymentNOCannotBeEmpty: '贸易-付汇编号不能为空',
  TradePaymentNumberCannotBeGreaterThanBitsInLength: '贸易-付汇编号不能大于16位长度',
  UnableToDeleteAllCharges: '不能全部删除费用.',
  PleaseCheckYourNetworkOrRefreshThePage: '亲,您现在正处于没有网络的异次元空间!请检查网络是否正常或者刷新页面。',
  TheFileIsSentSuccessfully: '文件发送成功.',
  PleaseSelectAFileToDownloadOrSend: '请选择需要下载或者发送的文件.',
  PleaseSelectAFileSynchronization: '请选择需要同步的文件.',
  PleaseSelectAFileCancelSynchronization: '请选择需要取消同步的文件.',
  FailedToModifyAFileType: '修改文件类型失败.',
  PleaseSelectAFileType: '请选择文件类型.',
  MBLNOCannotBeDuplicated: 'MB/L NO2不能重复！',
  PleaseSelectMBLNo: '请先选择MBL编号.',
  TotalWeightOfLadingAreInconsistent: '提单合计件毛体不一致！',
  TOORDERIsUnavailableToRelease: 'TO ORDER不可进行电放',
  TheAssociatedPrimaryFormIsNotSelected: '关联主单未选择',
  PleaseSelectHBLNo: '请先选择HBL编号！',
  PleaseEnterTheBillOfLadingSerialNumber: '请先输入提单流水号！',
  PleaseUploadReleaseGuarantee: '没有生效的电放保函，请先上传',
  TheRecipientAddressCannotBeEmpty: '收件人地址不能为空.',
  OperationIsNotReversible: '操作不可逆.',
  Uncommitted: '未提交',
  Approved: '已审核',
  Submitted: '已提交',
  Rejected: '已驳回',
  PleaseSelect: '请选择',
  Uploaded: '上传完成',
  Waiting: '等待上传',
  Uploading: '已经上传',
  Other: '其他',
  First: '第一页',
  Pre: '上一页',
  Page: '第',
  AllPage1: '共',
  AllPage2: '页',
  Next: '下一页',
  Last: '最后一页',
  ShowFromTo1: '显示',
  ShowFromTo2: '到',
  AllRecord1: '共',
  Transactions: '笔',
  AllRecord2: '记录',
  Convert: '折合',
  YouAreUnableToUseThisFunctionAsWHHasntBeenConfiguredIfNeedPleaseContactCSOnline: '亲，您未配置仓库，因此不能使用该功能，如有需要，请联系在线客服。',
  FirstSaveTheBusinessAutomaticLoadingIsInProgress: '亲，请先保存业务，在进行自动配货操作。',
  FirstSaveTheBusinessAddSpecialGoods: '亲，请先保存业务，再添加危险品',
  GeneralTrade: '一般贸易',
  ProcessingWithSuppliedMaterial: '来料加工',
  ProcessingTrade: '进料对口',
  SamplesOfAdvertisingProductsA: '货样广告品A',
  Refuse: '拒绝',
  Agree: '同意',
  GoOn: '继续',
  SubmitAudit: '提交主管审核',
  DataValidation: '正在进行数据验证',
  DataValidatedWithWarning1: '数据验证完成但存在警告,要继续',
  DataValidatedWithWarning2: '请点击【继续】,取消',
  DataValidatedWithWarning3: '请点击【取消】',
  DataValidatedSuccessfully1: '数据验证成功,确认',
  DataValidatedSuccessfully2: '请点击【确认】,取消',
  DataValidatedSuccessfully3: '请点击【取消】',
  DataValidatedFailure1: '数据验证失败,请对验证未通过的数据项处理后再',
  DataValidatedFailure2: '',
  WoChat: '沃聊',
  TheSystemHasBeenUpdatedPleaseTurnTheModuleOnAgain: '系统已经更新，请关闭模块重新打开.',
  TheSystemHasBeenUpdatedPleaseReLoginOrClearBrowserCache: '系统已经更新，请重新登录或清理浏览器缓存.',
  AddAdjustment: '增加调整',
  AddCharge: '增加费用',
  AddCostCharge: '新增应收费用',
  AddPayCharge: '新增应付费用',
  EditAdjustment: '修改调整',
  EditCharge: '修改费用',
  EditCostCharge: '修改应收费用',
  EditPayCharge: '修改应付费用',
  DeleteAdjustment: '删除调整',
  DeleteCostCharge: '删除应收费用',
  DeletePayCharge: '删除应付费用',
  DateOfAdjustmentCannotBeNull: '调整日期不能为空.',
  CurrencyOfAdjustmentCannotBeNull: '币种不能为空.',
  AmountCannotBeZero: '数量不能为零.',
  UnitPriceCannotBeZero: '单价不能为零.',
  AmountCannotBeZero2: '金额不能为零.',
  ExchangeCannotBeZero2: '汇率不能为零.',
  RemarkTheLengthCannotExceed: '备注长度不能超过50.',
  InvoiceNoCannotBeNull: '税金号不能为空.',
  InvoiceNoIsTooLong: '税金号长度过长.',
  PleaseAddSpecialGoodsFirst: '请先添加危险品',
  UNNoIsEmpty: '请填写联合国编号',
  LoadSpGoodsContainerError: '加载危险品装箱信息出错',
  AssociatedSpGoodsError: '关联危险品信息出错',
  NoAssociatedInfo: '没有关联信息',
  InnerPackagingTypeIsRequired: '内包装类型必须填写',
  InnerPackagingQuantityIsRequired: '内包装件数必须填写',
  SeaPollutionOnlyEnterYN: '海洋污染字段值必须是Y或N',
  SelectHsCode: '选择HS编号',
  SelectCargoChineseName: '选择中文品名',
  DispatchNotYet: '未派单成功，不允许更改派车单',
  AllDataMustBeOperating: '所有数据必须是正操作状态',
  TheSelectedDocumentInconsistentNatureOfTheContainerLoadType: '请选择整拼类型一致的业务',
  TheNumberOfChargesLimited: '费用最大数量不能超过',
  TheNumberOfSelectedDataLimited: '勾选的数据不能超过',
  PleaseInputSearchCondition: '请输入查询条件',
  PlaceOfDeliveryCannotBeNull: '交货地不能为空',
  ImportSuccessChargesCount: '成功导入{count}条费用',
  CheckChargeDetailBranch: '正操作的数据所在分公司不属于当前分公司或上一级分公司',
  ChangeSelectSales: '销售发生变更是否继续保存？',
  NoSelectedCargoDocInformation: '请选中一条提单记录!',
  OverseaCostChargeEmpty: '应收费用为空!',
  OverseasBillsCanNotBePrinted: '海外账单无法打印(账单为空、未选择、已作废、没有权限)!',
  CheckHBLReleaseStateBeforePrint: '不是可放单，无法打印!',
  NoSelectedWarehouseInInformation: '没有选择需要打印的仓储信息！',
  NoWarehouseInInformation: '您选择的仓储信息有误！',
  ConfirmTheShutOut: '确定要作废该票业务吗？所有的费用会被删除！',
  SaveSucceed: '保存成功!',
  SelectOneJob: '只允许勾选一票业务进行复制！',
  PleaseInputETD: '请选择开航日期范围！',
  SelectJob: '请选择业务！',
  DateToday: '今天',
  PleaseSelectSoNo: '请选择关单号',
  ChargeOffsetState: '费用已经红冲或者被红冲',
  isDeleteAllEDIContainer: '是否清空全部装箱信息',
  ServiceCodeCannotBeNull: '服务代码不能为空',
  Choose: '选中',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeForceDel: '此账单已提交财务审核,不能被强制删除.',
  ThisVerificationHasBeenDoneAndCannotBeForceDel: '此单已做过核销,不能被强制删除.',
  ThisFormIsLockedAndCannotBeForceDel: '此单已被锁定,不能被强制删除.',
  ConfirmTheForceDelOfTheBill: '确定强制删除该账单？',
  ForceDelSuccessfully: '强制删除成功',
  IsNotOperationStatusCannotBeShutOut: '只能批量退关“正操作”状态的业务',
  IsNotOperationStatusCannotBeCancellation: '只能批量作废“正操作”状态的业务',
  ManifestLink: '舱单链接如下',
  ApplicationAmountCheck: '付款申请金额与费用列表总金额不匹配，请检查！',
  TipsOnSplittingExpenses: '拆分费用金额不可大于原费用金额，请修改拆分费用金额！',
  DcCopyCheck: '该业务有单证人员无部门或公司信息，请重新选择单证！',
  CsrCopyCheck: '该业务有客服人员无部门或公司信息，请重新选择客服！',
  SureDeleteThese: '确定要删除这',
  OrdersOfBusiness: '票业务吗？',
  SureCancellationAndDeleteCharge: '确定要作废业务吗？所有费用会被删除！',
  SureShutOutAndDeleteCharge: '确定要退关吗？所有费用会被删除！',
  CheckingConsignation: '该业务不能委托，请检查后重试！',
  TheSubBillHasBeenConsolidatedAndCannotBeDelete: '该小票已拼过箱，不能删除。',
  SaveFailedMessage: '保存失败，请刷新后重试！',
  SettlementAgentCannotBeNull: '结算代理不能为空！',
  SettlementAgentErrorPleaseReSelect: '结算代理错误，请重新选择！',
  NowContainer: '当前箱子',
  NowContainerCanNotDelete: '当前箱子已占用，不能删除！',
  NotDelete: '不能删除！',
  PleaseSelectBoxType: '请选择箱型箱种！',
  PleaseEnterUnitPrice: '请输入单价！',
  PleaseSelectCurrency: '请选择币种！',
  PleaseEnterTheStartDate: '请输入起租日期！',
  PleaseEnterThebuyDate: '请输入买箱日期！',
  PleaseEnterEndDate: '请输入结束日期！',
  SuccessfulBoxAdjustment: '调箱成功！已处理数量',
  NoBoxesProcessedSuccessfully: '无成功处理箱子，请检查实际装箱！',
  OnlyBuyCaseOrderBoxCanBeSold: '只能售卖买箱订单箱子，请检查！',
  ChoiceCaseSell: '请选择相同币别的箱子进行售卖！',
  PleaseContainerData: '请输入箱子信息！',
  UnifiedCurrency: '卖箱订单只支持单币种，请统一卖箱币种！',
  PleaseCheckTheBoxToBeSold: '请勾选需出售的箱子！',
  EditedFailMessage: '修改失败，请刷新后重试！',
  DataValidatedWithPartialPass1: '数据验证完成但存在部分警告和失败,要继续',
  DataValidatedWithPartialPass2: '请点击【继续】,取消',
  DataValidatedWithPartialPass3: '请点击【取消】 注：验证失败的，请对验证未通过的数据项处理后再',
  AddChangeCharge: '新增改单费用',
  ThereAreNoPayableBillsToPrint: '没有可付款的单子可打印.',
  ReleaseInformationNotSelected: '放单信息未选择',
  AreYouSureYouWantTo: '请确定要{0}吗？',
  NoRecordsAvailable: '没有记录可{0}.',
  NoDataToAudit: '没有可以审核的数据.',
  NoSplittingRecordSelected: '未选择分单记录.',
  NoDataToAudit2: '没有可以{0}的数据.',
  EditChangeCharge: '修改改单费用',
  AddSpecialCharge: '新增特殊费用',
  AddBusinessSpecialCharge: '新增商务特殊费用',
  EditSpecialCharge: '修改特殊费用',
  EditBusinessSpecialCharge: '修改商务特殊费用',
  AddSpecialUpdate: '特殊费用调整',
  Pstsftba: '请选择需要调整的特殊费用!',
  Nsecbe: '不能编辑非特殊费用!',
  UpdateWarehouseRecord: '仓库发生变更是否继续保存？',
  CheckCostAndBusinessMismatching: '勾选的费用项与业务不匹配',
  TicketEntrustedCannotRepetitionDelegate: '该票已委托，请勿重复委托！',
  NotFindCurrencyRatePleaseMaintain: '找不到币种{0}的汇率,请及时维护相关汇率,再进行保存!',
  BillPaymentDeleteTips: '只能删除不是已 财务审批和未核销状态的付款申请单',
  SettlementAgentNotNull: '结算代理不能为空！',
  PleaseSelectSameSettlementAgent: '请选择相同结算代理的账单！',
  TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue: '新选小票目的港代理,装货港,目的港,订舱代理,航空公司,航班,ETD,订舱性质,主单运费条款\n与主票不一致，系统将修改小票,是否继续？',
  AMS_ReturnMessage: 'AMS提箱件毛体信息与实际不符,请调整！\n',
  AMS_ReturnMessageCanSave: 'AMS提箱件毛体信息与实际不符，是否继续保存？\n',
  AMS_Quantity: '【AMS件数{0} {1} 实际件数{2}】\n',
  AMS_Weight: '【AMS毛重{0} {1} 实际毛重{2}】\n',
  AMS_Cubage: '【AMS体积{0} {1} 实际体积{2}】\n',
  AMS_ContainerNo: '箱号【{0}】：\n',
  CheckPortsByConsignation: '您委托的【{0}】没有维护【{1}】港口，请跟对方核对后再进行委托！',
  CheckPackingByConsignation: '您委托的【{0}】没有维护【{1}】包装，请跟对方核对后再进行委托！',
  CheckCompanyByConsignation: '您委托的【{0}】没有维护【{1}】的SCAC码等相关信息，请跟对方核对后再进行委托！',
  CheckCarrier: '请先维护好【{0}】的SCAC码，再进行委托！',
  SettleAccountMustBeSame: '结算对象必须相同',
  ReceivableCannotMorethanPay: '应收费用不能大于应付费用',
  PleaseSelectJobs: '请选择业务单记录',
  SapCommitCheck: 'SAP一次交单已完成，请勿重复交单',
  SapCancelCommitCheck: '费用无法撤回SAP状态，请确认费用的SAP状态',
  escnm: '费用结算部门未维护',
  SapSynchronizationSuccess: 'SAP同步费用成功',
  SapSynchronizationFault: 'SAP同步费用失败',
  SapStatusCanNotAudit: '费用无法审核SAP状态，请确认费用的SAP状态',
  ChangeOrderSubmissionFailed: '改单提交失败，没有检测到需要改单的费用！',
  SureYouWantToDeleteFilesTwo: '确定要批量删除这{0}个文件吗?',
  JumpFailed: '跳转失败',
  SelectCopyContent: '选择复制内容',
  CopyContent: '复制内容',
  SelectImportContent: '选择导入内容',
  ImportContent: '导入内容',
  DifferenceOverwritesTheOriginalValue: '差异字段覆盖原值',
  DifferenceRetainsTheOriginalValue: '差异字段保留原值',
  RememberToChoose: '记住我的选择',
  TheImportedServiceNumberDoesNotExistProcedure: '导入失败，导入的业务编号不存在，请重试！',
  TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService: '导入与被导入的业务编号不能相同',
  CopyNumber: '本次复制数量',
  QuickSearchBusinessNo: '快捷检索:业务编号',
  QuickSearchChineseName: '快捷检索:中文名称',
  FinancialDateOfASingleExpense: '确定要修改单笔费用财务日期吗?',
  ExpenseFinancialDateModifiedSuccessfully: '费用财务日期修改成功',
  ModifyTheFinancialDate: '确定要修改财务日期吗？',
  FinancialDateModifiedSuccessfully: '财务日期修改成功',
  ApprovalDateIsEarlierThanBusinessDate: '审核日期小于业务日期，是否继续？',
  AreYouSureToReviewTheseLists: '确定审核这些单子吗？',
  ThisBusinessIsNotApproved: '该业务不是[{0}]状态，不允许审核，请检查！',
  ThisBusinessIsNotApproved2: '该业务不是[{0}]状态，不允许撤回，请检查！',
  TheDocumentChangeSubmission: '确定要撤回改单提交吗？',
  AllowOrderChange: '确定要允许改单吗？',
  AllowToChangeTheOrderSuccessfully: '允许改单成功',
  NoExpenseSelectedOrNotInApprovalStatus: '未选择费用或不是审核状态',
  ExpenseStatusUpdatedSuccessfully: '费用状态更新成功',
  BusinessHasGeneratedVouchers: '业务已生成凭证，',
  UnableCancelAudit: '无法取消审核。',
  BusinessNumberWithGeneratedVouchers: '含已生成凭证的业务编号：',
  AreYouSureYouWantToCancelTheApproval: '确定要取消审核吗？',
  LCLTicketsCannotBeReviewedSeparately: '拼箱小票不能单独审核，请审核主票。',
  ItIsLocked: '已被锁定,不能打印,请联系上级主管解锁!',
  PleaseSelectTheBusiness: '请选择需要修改业务日期的业务',
  BusinessDateModifiedSuccessfully: '业务日期修改成功',
  BatchApprovalFailed: '批量审核失败',
  PleaseSelectTheBusinessToPrint: '请选择需要打印的业务',
  NoInTheSelectedData: '选择的数据中有不是【{0}】状态的业务，不允许审核，请检查！',
  TheApprovalDateIsEarlierThanTheBusinessDate: '审核日期小于业务日期,是否继续?',
  FailedToGetDetails: '获取详情失败',
  PleaseEnterTheBoxSealNumber: '请输入箱封号后，打印利润分析表。',
  AfterPrintingTheProfitAnalysisStatement: '打印利润分析表后, 本单业务将提交财务审核,不可再更改.是否继续？',
  PleaseEnterTheApprovalDate: '请输入审核日期',
  PleaseSelectARecordToView: '请选择一条记录进行查看',
  ContractExpireCannotCreated: '该委托单位合同到期，不能再创建业务',
  CheckBusinessStatus: '操作失败，请检查业务对应的状态是否正常。',
  CheckCustomsSaved: '请先保存报关单信息，再上传报关资料！',
  SelectCustomsBroker: '请选择报关行.',
  SelectCustomsBrokerPlatFormProvider: '您未在合作伙伴中，给当前所选报关行配置“平台供应商”，不可发送.',
  SelectCustomsSonoLobFiles: '关单号”，报关行，报关资料，业务类型不可为空，请核对数据',
  VesselAndvVoyageFlightisEmpty: '船名航次为空，请问是否确定发送',
  customsInfoIsAlredySend: '此报关单已发送过，暂时支持发送一次，如需修改请线下联系对应报关行',
  DocumentEditedTips: '你不是该票的单证，不能编辑。',
  NotGroupBusinessesCannotBeEdit: '非同组业务，不可进入编辑',
  CustomerTipMessage: '【{0}】不是委托单位，请重新选择！',
  PortOfLoadingPortCannotBeNull: '装货港不能为空',
  PromissoryNoteIsAFormalBusiness: '本票已是正式业务！',
  CannotBeConvertedToFormalBusinessInBatch: '包含业务来源是“ 租户内自身业务”的信息，无法批量处理转正式业务。',
  whetherToTransferSmallTicketToFormalBusinessAtTheSameTime: '是否将小票同时转正式业务？',
  transferSmallTicketToFormalJobAtTheSameTime: '小票同时转正式业务',
  onlyTheMasterTicketIsTransferredToFormalJob: '仅主票转正式业务',
  pleaseTransferTheCorrespondingMasterTicketToFormalJobFirst: '请先将对应的主票转正式业务！',
  BusinessCannotBeOperatedTogether: '常规业务与委托业务不能一并操作，请重新选择！',
  PleaseEnterTheWarehouseNumber: '快捷检索:进仓编号',
  BookingSeal: '订舱章',
  CheckSplitCharges: '费用已做拆分，请先删除拆分费用',
  mutualChargeSynchronizationSuccess: '交叉委托费用同步成功！',
  mutualChargeSynchronizationFault: '交叉委托费用同步失败！',
  confirmQuit: '确定退出吗？',
  SelectMBL: '提单号（订舱页签-MB/L NO）不可为空',
  SelectMBLSI: '主单号（进口操作-主单号）不可为空',
  SelectMBLAE: '主单号（基本-主单号）不可为空',
  SelectMBLAI: '主单号（空运操作-主单号）不可为空',
  SelectLob: '请选择业务类型.',
  SelectPreCustomsDate: '请选择预报关日期.',
  SelectHarborDistrictSe: '港区（订舱页签-港区）不可为空',
  SelectHarborDistrictSi: '港区（进口操作-港区）不可为空',
  DestinationPlaceNotNull: '交货地（进口操作-交货地）不可为空!',
  AirportPortNotNull: '机场口岸不可为空',
  ExpectedDateOfArrivalNotNull: '预计到港日期（进口操作-到港日期）不可为空!',
  SelectCustomsFiles: '请选择报关资料.',
  CustomsHasBeanSend: '此报关单已发送过，暂时支持发送一次，如需修改请联系对应报关行',
  FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe: '单个文件不能超过20M，请线下邮件发送至xh08@thecustoms.com.cn邮箱',
  PleaseUploadFileSeaExport: '请上传报关委托书、配舱信息、出口报关单草单及商品申报要素、发票、箱单等文件。',
  PleaseUploadFileSeaImport: '请上传报关委托书、整箱海运提单、提货单信息或复印件、发票、箱单、合同、产地证、商品申报要素等文件。',
  PleaseUploadFileAirExport: '请上传报关委托书、提运单，出口报关单草单等文件。',
  PleaseUploadFileAirImport: '请上传报关委托书、到货通知书、空运提单、发票、箱单、合同、产地证、商品申报要素等文件。',
  SuccessfulCustoms: '报关成功!',
  FaildCustoms: '报关请求失败，请联系管理员!',
  AsyncReceivableChargesToImportJob: '所有应收费用都会同步到进口业务中，是否确认继续？',
  AsyncPayableChargesToImportJob: '所有应付费用都会同步到进口业务中，是否确认继续？',
  escnm2: '费用结算部门不能为空。',
  SelectMoreTwoRow: '请至少选择两条数据进行组合！',
  OnlySplitMasterJob: '只能拆分主票！',
  SplitJobTip: '请勾选整拼类型为Buyer Console FCL的主票，业务状态为正操作的主票进行拆分！',
  CombinationJobSelectMasterTip: '是否确定将以下业务进行组合，请选择一票业务员作为主票？',
  CombinationJobForFcl: '整拼类型为整箱和Buyer Console FCL',
  CombinationJobForJobState: '业务状态为正操作状态',
  CombinationJobForCustomer: '委托单位一致',
  CombinationJobForVessel: '船名一致',
  CombinationJobForVesselVoyage: '航次一致',
  CombinationJobForMaster: '请选择主票！',
  CombinationJobTip: '请选择{0}的业务进行操作！',
  ValidateCombinationJobTip: '提单号为{0}的业务已被使用，请点击取消按钮，重新进行组合操作！',
  OnlyJoinForCombinationJob: '只允许加入整拼类型为整箱和Buyer Console FCL的业务！',
  TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue: '开票抬头不一致，是否继续？',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2: '新选小票的船名、航次、承运人、订舱代理、目的港代理、ETD、ETA、仓库信息、船公司约号与主票不一致。系统将修改小票。是否继续？',
  HblNoMoreThanTwelve: '分单号不能超过12位！',
  WriteOffPushSuccess: '核销记录推送成功！',
  WriteOffPushError: '核销记录推送失败！',
  CancelConfirmBill: '是否同步取消费用确认状态？',
  AreYouSureYouWantToDeleteTheSelectedFee: '是否确认删除选中的费用?',
  JobOfClosingAccountTip: '业务日期无法保存，请调整后保存！',
  ThePacketHasBeenSentAndWhetherToImportItAgain: '已经发送过报文，是否再次导入？',
  PleaseCheckAtLeastOnePieceOfData: '请至少勾选一条数据',
  NoHasViewRole: '没有查看权限，请联系管理员进行配置！',
  NoHasViewBillingRole: '没有查看账单权限，请联系管理员进行配置！',
  NoHasViewBillingGroupRole: '没有查看对账单权限，请联系管理员进行配置！',
  checkSpecialChargeTips: '销账记录中含有特殊费用的不能生成凭证，请重新选择！',
  CheckCustomJobTypeTips: '请选择自定义业务类型，再进行保存！',
  AMSCodeCannotBeNull: '基本配置AMSCompanyCode不能为空!',
  MblNoIsOverLength: '【MB/L NO】字段超过16位。',
  AmsNoIsOverLength: '【AMS NO】字段超过12位。',
  IsOverLengthTip: '{0}字符超长，每行数据请勿超过{1}个字符。',
  UnitTypeNotNull: 'Unit Type不可为空，请录入',
  Shipper: '发货人',
  Consignee: '收货人',
  Notify: '通知人',
  SecondNotify: '第二通知人',
  SpecialCharacter: '{0}字段含有非法字符，无法保存！',
  TipsOnAutoSplittingCharge: '请输入拆分费用的含税价上线！',
  DeleteSmallTicketTips: '您没有删除小票的权限！',
  SyncToSmallTicketSuccessTips: '{0}节点状态已同步到小票！',
  OperationTypeInUsed: '{0}{1}已经有默认显示的{2}运输条款，请重新选择！',
  StartUpdatingTheBasicData: '开始更新基础数据',
  BasicDataUpdateSuccessfully: '基础数据更新成功',
  BatchSubmitCheck: '只能批量提交正操作或预提交的单子!',
  isExistHBLANDMBLTips: '一个主单号下的分单号码不允许重复，请重新输入分单号！',
  operateTypeUpdateTips: '操作模式变更，是否更新MAWB收发通信息',
  SettlingAgentInconsistent: '结算代理不一致，是否继续？',
  SettlingAgentInvoiceTitleInconsistent: '结算代理和开票抬头都不一致，是否继续？',
  ChargeEmpty: '费用为空！',
  NoChargeForTheSettlementOfPrint: '没有符合打印条件的费用结算对象.',
  PleaseEnterTheCreationDate: '请输入创建日期。',
  SelectDate: '选择日期',
  DefaultCurrency: '默认币种',
  EDISUBMISSIONCenter: 'EDI 报送中心',
  EDICenter: 'EDI中心',
  MessagePreview: '报文预览',
  MessageDesign: '报文设计',
  ReceiverCodeCannotBeEmpty: '接收方代码不能为空',
  SelectEDIType: '选择EDI类型',
  NotConfigured: '未配置',
  SelectSendingChannel: '选择发送渠道',
  SelectFileNature: '选择文件性质',
  SelectFileTemplate: '选择文件模板',
  SelectedBusiness: '已选业务：',
  BackToEDICenter: '回到EDI中心',
  Design: '设计',
  SendAll: '发送全部',
  Tips: '提示：',
  UsedInTemplateDesign: '模板设计中使用',
  Check: '进行校验',
  SentSuccessfully: '发送成功！！',
  TemplateSavedSuccessfully: '模板保存成功',
  OtherDocuments: '其他文件',
  ClickUpload: '点击上传',
  UnsupportedFileType: '不支持的文件类型',
  TheSizeExceedsTheLimit: '文件大小超出了限制',
  UploadFailed2: '上传失败了',
  PleaseSelectABusinessNumber: '请选择业务编号',
  TheExceeds20MBAndUploaded: '1个文件体积超过20MB,不能进行上传.',
  UploadPleaseContactTheAdministrator: '上传失败，请联系管理员。',
  FailedPleaseRefreshAndAgain: '获取数据失败，请刷新后重试',
  ExternalImportedDataNonEditable: '外部导入数据，不可编辑',
  ExternalDataCannotBeDeleted: '外部导入数据，不可删除。',
  RequestSucceededExporting: '请求成功，正在导出！',
  Main: '主要',
  PleaseEnterTheWarehousingNumber: '请输入进仓编号！',
  PleaseEnterTheWarehouseName: '请输入仓库名称！',
  PleaseEnterTheWarehouseInDate: '请选择入库时间！',
  PleaseMaintainWeighDetail: '请先维护称重（实际）货物明细！',
  PleaseEnterComments: '核单结果不通过，请填写处理意见！',
  PleaseSelectTheClosingWeight: '请选关封重量!',
  SureToSaveLabeling: '还未称重，请确认是否保存贴标信息？',
  PleaseLengthWidthPieces: '请输入正确格式的尺寸:长*宽*高*件数！',
  PleaseTheNumberOfPieces: '请输入件数！',
  WarehouseNumberAlreadyExistsContinue: '进仓编号已经存在,是否继续',
  SavedSuccessfully: '保存成功！',
  ChecklistSuccessfully: '核单状态更新成功！',
  NoSynchronizationContent: '暂无同步内容',
  ThereSynchronizationSpecialGoodsSynchronize: '装箱信息中有被特殊货物关联箱子，同步后特殊货物需重新关联，是否确认同步?',
  SynchronizationSucceeded: '同步成功',
  SynchronizationFail: '同步失败',
  ThisJobIsNotWorkingCanNotBeEdited2: '指定业务不是正操作状态, 不能执行同步',
  ASameBoxTypeExists: '已经存在一条相同箱型箱种的记录!',
  IfToRefreshTheContainers: '箱量发生更改，是否刷新原有按箱数为单位的费用?',
  BusinessCannotBeEmpty: '业务不能为空！',
  ViewChargebackFile: '查看退单文件',
  SelectDepartment: '选择部门',
  PleaseSelectADepartment: '请选择部门！',
  ReceiptSucceeded: '回执成功',
  ReceiptError: '回执错误',
  SubmittedForDeletion: '已提交删改',
  ModificationFailed: '修改失败',
  EDIStatusChangeRecord: 'EDI 状态变更记录',
  FeedbackNode: '反馈节点',
  YouTheLinkAddressDirectly: '直接复制链接地址即可对单',
  HistoricalAnomaly: '历史异常',
  TimeOfOccurrence: '发生时间',
  VerificationOfEstimatedProfitMargin: '预估利润率验证',
  EstimatedIncome: '预估收入',
  EquivalentToRMB: '折合人民币',
  EstimatedCost: '预估成本',
  EstimatedProfit: '预估利润：',
  EstimatedProfitMargin: '预估利润率：',
  EstimatedRemarks: '预估备注：',
  EstimatedMustBeFilledIn: '预估备注必须填写.',
  Sunday: '星期日',
  Monday: '星期一',
  Tuesday: '星期二',
  Wednesday: '星期三',
  Thursday: '星期四',
  Friday: '星期五',
  Saturday: '星期六',
  SelectFileType: '选择文件类型',
  FileInformation: '文件信息',
  Thumbnail: '缩略图',
  DownloadPhotos: '下载照片',
  UploadComplete: '上传完成!',
  UploadFailedSigh: '上传失败!',
  HelloNNPleaseCheck: '您好,\n\n请查收',
  WarehousingNo: '进仓编号-',
  WarehousingNoColon: '进仓编号为:',
  PhotosNthankYouN: '的照片\n\n谢谢\n\n',
  SendingSucceeded: '发送成功!',
  SendingFailed: '发送失败!',
  PleaseTheFileToDownload: '请选择需要下载的文件.',
  WaybillNo: '运单号为:',
  ConfirmSending: '确定发送',
  ReturnToModify: '返回修改',
  ChannelName: '通道名称',
  PleaseSelectASendingChannel: '请选择一个发送通道！',
  FailedToGetTemplate: '获取模板失败',
  TheDocumentOfTheContinue: '新选小票的船名航次，船公司，主单号，换单代理，开航日期，预计到港日期，实际到港日期，仓库，主单放货方式和主单运费条款与主票不一致；或小票海关分单号为空。\r\n系统将修改小票。是否继续？',
  PleaseSelectACodingRule: '请选择编码规则.',
  ApplicationForRelease: '申请放舱',
  ApplyForShipperCode: '申请SHIPPER CODE',
  NoDataSelected: '未选中数据！',
  InvalidFee: '无效费用!',
  ReceivingMethod: '接收方式：',
  CellPhoneNumber: '手机号：',
  NoteDoesNotAffectPartner: '注：此页面修改的信息不影响合作伙伴原本的配置',
  emptySopNodeWarning: '推送节点为空将无法正确推送消息',
  AsynchronousLocking: '后台正在进行异步锁单，稍后可去右上角(消息)查看结果',
  AsynchronousJobAccountVerify: '后台正在进行异步处理，稍后可去右上角(消息)查看结果',
  RepeatClick: '后台正在执行锁单操作，请勿重复点击',
  RepeatClickJobAccountVerify: '后台正在执行审核操作，请勿重复点击',
  RepeatClickJobAccountVerify2: '后台正在执行取消审核操作，请勿重复点击',
  AddFromPartner: '从合作伙伴添加',
  AddManually: '手动添加',
  ReceivingMode: '接收方式',
  PushNodeCannotBeEmpty: '推送节点不能为空！',
  PushBeEmptyPleaseCheck: '推送节点不能为空，请检查：',
  DetailedNumberOfCheckedGoods: '勾选的货物明细件数',
  NumberAssociatedPackingInformationPieces: '关联的装箱信息件数',
  DetailedWeightOfGoodsChecked: '勾选的货物明细重量',
  AssociatedPackingInformationWeight: '关联的装箱信息重量',
  DetailedVolumeOfGoodsChecked: '勾选的货物明细体积',
  AssociatedPackingInformationVolume: '关联的装箱信息体积',
  CopyShippingMarkAndName: '从委托唛头品名抄录',
  OperationCategory: '操作类别',
  PleaseEnterTheBusinessNumber: '请输入业务编号.',
  NonExistent: '不存在.',
  ContainerTip: '该箱子已同费用关联，请先解除关联关系后再修改箱号',
  UploadCustomsDeclarationFile: '上传报关文件',
  UploadChargebackFile: '上传退单文件',
  RevenueTypeCannotBeBlank: '【收支类型】不能为空!',
  SettlementCompanyCannotBeBlank: '【结算单位】不能为空!',
  IncorrectFormatOnlyIntegerSupported: '税率数据格式不正确，只支持整数!',
  domesticForeignCannotBeEmpty: '【国内国外】不能为空!',
  ImportResults: '导入结果',
  AllSuccess: '全部成功',
  AllFailed: '全部失败',
  PartialFailurePartialSuccess: '部分失败,部分成功',
  OddNumbers: '单号',
  PleaseTheSameBusinessOperate: '请选择同种业务类型的业务进行操作！',
  OperationError: '操作错误了',
  NewBusiness: '新增业务',
  ThePleaseRefreshAndAgain: '系统繁忙，请刷新重试',
  SubmittersRemarks: '提交人备注',
  PleaseFillInTheRemarks: '请填写备注',
  YouAreNotTheSubmitter: '非提交人上级主管，不能操作本业务！',
  PleaseFillInTheRemarksSigh: '请填写备注信息！',
  PleaseEnterRemarks: '请输入备注信息！',
  TheTheCurrentOperationMaintenance: '当前操作未维护上级主管，请维护之后再提交本业务！',
  FailedForApprovalPleaseAgain: '提交主管审核失败，请刷新重试！',
  SubmittedSupervisorForApprovalSuccessfully: '提交主管审核成功',
  ApprovedPass: '审核已同意！',
  ApprovalRejected: '审核已拒绝！',
  Problem: '问题',
  Synchronized: '已同步',
  NotSynchronized: '未同步',
  YouToEditTheAdministrator: '您没有编辑数据的相应权限,请联系管理员',
  SentOut: '已经送出!',
  DefaultPSettlementID: '默认固定应付结算对象Id',
  IsAREmpty: '默认应收对象是否为空',
  IsAPEmpty: '默认应付对象是否为空',
  TheFormCannotBeEmpty: '报关单不能为空！',
  ReminderOfTheCustomsData: '提醒：上传报关资料前请先点击确定保存报关单必填信息',
  ReminderOfTheCustomsPrint: '提醒：以下数据不会推送报关行，仅用于打印单据数据源',
  ObtainActualBusinessData: '取业务实际',
  TheToBeViewedAnyone: '文件不允许任何人查看或下载.',
  YouPermissionToViewDownload: '你没有权限查看或下载',
  File: '文件',
  PleaseInTheSubmissionNotes: '请填写提交备注',
  ContainsInvoicesThatCannotBeModified: '含有不可修改的发票',
  RemarksReviewedBy: '审核人备注',
  numberingRuleCannotBeEmpty: '【编号规则】不能为空!',
  PortAreaDataComparison: '港区数据对比',
  ImportMode: '导入方式',
  Keep: '保持',
  Explain: '说明：',
  BlackIsTheInputData: '黑色为录入数据，',
  BlueThePortAreaData: '蓝色为港区数据，',
  GrayIsPreEnteredData: '灰色为预录入数据',
  UpdatedToPortAreaData: '更新为港区数据',
  lclCompareHarbourTips1: '1.默认全部覆盖（“港区的数据”全部覆盖“系统录入”数据），不勾选表示保留系统数据，港区数据不覆盖；全部取消勾选，则保留原系统数据',
  lclCompareHarbourTips2: '2.红色表示对比“系统数据”与“港区数据”不一致的信息',
  lclCompareHarbourTips3: '请尽快确认正确的装箱信息，它会影响到后续SOP以及箱货预警信息推送显示',
  UpdatedData: '更新数据',
  compareHarbourTips1: '1.默认全部覆盖（港区的数据全部覆盖系统录入数据）',
  compareHarbourTips2: '2.点击箱号切换查看信息，红色表示对比“系统数据”与“港区数据”不一致的信息',
  compareHarbourTips3: '3.在【其他】不勾选，则“系统数据”保持原装箱数据不变、“港区数据”不会新增装箱信息；在对应的【箱号】里面不勾选，则保留“系统数据”；\n全部取消勾选，则保留原系统数据',
  compareHarbourTips4: '请尽快确认正确的装箱信息，它会影响到后续SOP以及箱货预警信息推送显示',
  SystemEntry: '系统录入',
  PortAreaData: '港区数据',
  ImportDescriptions: '导入类型为修改，为系统分别根据箱号、箱型、箱种帮您匹配到与港区一致的数据。\n导入类型为新增，为系统未找到与港区数据一致的数据。\n导入类型为保持，为您录入的数据未匹配到港区数据，即为您原始录入数据。',
  WhenTheBoxIsIdentifiedAsABox: '箱货标识为箱子时，不显示关单号，件毛体的数据为货物的合计。',
  ClickEnteredDataPleaseOperation: '点击【更新为港区数据】，系统将会根据已勾选的信息更新系统录入数据为港区数据，同时字体颜色会变成黑色，请确认港区数据无误后再操作。',
  Determine: '确 定',
  Cancel2: '取 消',
  PleaseAtLeastOneRecord: '请至少选择一条记录！',
  Hello: '您好',
  EnclosedPleaseFind: '请查收',
  PhotosOf: '的照片',
  ThankYou: '谢谢',
  TheAndFreightTermsBlank: '新选小票的船名航次，船公司，主单号，换单代理，开航日期，预计到港日期，实际到港日期，仓库，主单放货方式和主单运费条款与主票不一致；或小票海关分单号为空。',
  TheModifyTheSmallContinue: '系统将修改小票。是否继续？',
  SaveFailedSigh: '保存失败!',
  CellPhoneNumber2: '手机号',
  NoSopNodeMatched: '未匹配到当前业务的节点，请重新选择',
  NameCannotBeEmpty: '姓名不能为空！',
  PleaseSelectARecord2: '请选中一条记录.',
  ChangePassword: '修改密码',
  OriginalPassword: '原密码',
  NewPassword: '新密码',
  ConfirmPassword: '确认密码',
  ModificationPleaseLogInAgain: '修改成功，请重新登陆',
  TheEnteredTwiceAreInconsistent: '两次输入的密码不一致',
  DearUser: '亲爱的用户：',
  ItSystemInOrderMode: '监测到您当前浏览器模式为兼容模式，会影响CargoWare系统运行速度，为提升系统运行速度及操作效率，请切换极速模式。',
  TheShownInTheBelow: '具体操作如下图所示：',
  ToSwitchTutorialsSee: '切换教程请查看：',
  GotIt: '知道了',
  FullScreen: '全屏',
  EarlyWarningReminder: '预警提醒',
  AnnouncementMessage: '公告消息',
  Cancellation: '注销',
  FlagshipEdition: '旗舰版',
  BasicEdition: '基础版',
  TrialCustomers: '试用客户',
  FormalCustomer: '正式客户',
  SystemAdministrator: '系统管理员',
  RefreshCacheMethod: '刷新缓存方法',
  AfterTheCorrespondingCacheData: '维护完基础资料后，请更新相应缓存以获取最新数据。',
  ViewCacheRefreshMethod: '查看缓存刷新方法',
  PleaseExitTheEditingModule: '请先保存更改的数据，或退出编辑状态，然后关闭模块。',
  SessionPleaseLogInAgain: '会话超时，请重新登陆',
  EDITemplateExceptionDownloadFailed: 'edi模板异常，下载失败....',
  One: '一',
  Two: '二',
  Three: '三',
  Four: '四',
  Five: '五',
  Six: '六',
  Just: '刚刚',
  MinutesAgo: '分钟前',
  HoursAgo: '小时前',
  OneDayAgo: '1天前',
  LastWeek: '最近一周',
  LastMonth: '最近一个月',
  LastThreeMonths: '最近三个月',
  PleaseSelectDataFirst: '请先选择数据',
  SelfBooking: '自订舱',
  CommissionedBooking: '委托订舱',
  CustomerSelfBooking: '客户自订舱',
  OwnContractPrice: '自有约价',
  CustomerOffer: '客户约价',
  OverseasAgentContractPrice: '海外代理约价',
  UncommittedPrice: '无约价',
  PeerAgreementPrice: '同行约价',
  BuyerLCL: 'BUYER拼箱',
  InnerPacking: '内装箱,',
  DoorPointPacking: '门点装箱,',
  SelfPullingAndSelfSending: '自拉自送,',
  DeclareAtCustoms: '报关,',
  Fumigation: '熏蒸,',
  CommodityInspection: '商检,',
  BookingSpace: '订舱,',
  SetSpell: '集拼',
  PersonalBelongings: '私人物品',
  OneMasterAndManyPoints: '一主多分',
  OneMasterAndOneMinute: '一主一分',
  UnknownType: '类型未知',
  Marked: '已标记',
  Unmark: '未标记',
  PendingOrder: '待下单',
  OrderPlaced: '已下单',
  ReceivedOrder: '已接单',
  NotIssued: '未签发',
  Issued: '已签发',
  Retrieved: '已取回',
  Accepted: '已接收',
  Claimed: '已认领',
  ChangeOrder: '改单中',
  ApprovedBusinessCannotBeEdited: '已审核的业务不能被编辑.',
  OrderAlreadyApproved: '{0}订单已审核.',
  YouPermissionToEditNotes: '您没有权限编辑本票.',
  EnglishNameOfHBLConsignee: 'HBL收货人英文名称',
  EnglishNameOfHBLShipper: 'HBL发货人英文名称',
  AgentNetworkCustomerService: '代理网络客服',
  ReImportAfterModification: '可修改后重新导入',
  DownloadFailedData: '下载失败数据',
  TheCaseOfMultipleFirst: '延长期限不推荐在多选情况下使用,请先检查是否存在多余勾选!',
  InvalidNumberEntered: '输入数字无效!',
  TheOrThePartnerSigned: '该客户已签单或该合作伙伴已被签单！',
  FirstDateCannotBeBlank: '初次接触日期不能为空!',
  PleaseInTheTelephoneNumber: '请填写电话！',
  PleaseRemoveTheTicketFirst: '请先移除小票',
  ExpenseHasBeenEntered: '已录入了费用',
  ConsolidationHasBeenDone: '已做过并单',
  Save: '是否保存？',
  PleaseEnterCurrencyExchangeRate: '请输入币种汇率',
  FailedOpenSalesQueryDetails: '销售查询详情打开失败！',
  pleaseEnterTemplateName: '请输入模板名称',
  blank: '空白',
  PartnersBeenAddedToBlacklist: '合作伙伴已被加入黑名单!',
  ThisCustomerRiskyCustomerOperateOrdersWithCaution: '此客户为风险客户请谨慎{0}订单!',
  AlreadyExistsOverwriteOriginalScheme: '方案名称已存在，是否覆盖原有方案？',
  NoDataToSave: '没有数据可保存',
  ColumnSettings: '列设置',
  CurrentPage: '当前页',
  CurrentSelection: '当前选择',
  NoModificationAllowedAfterBusinessSubmission: '业务提交后将不允许修改,提交前请确认相关文件是否已经上传',
  AboutToUploadFiles: '即将上传文件',
  SuccessfullyUploaded: '成功上传',
  RetrievalOfAssignedPermissions: '已分配权限检索',
  UploadResults: '上传结果',
  OnlyFilesFormatCanUploaded: '只能上传格式为{0}的文件',
  VolumeAbnormalAndCannotUploaded: '文件体积异常,不能进行上传.',
  VolumeExceeds5mAndCannotUploaded: '文件体积超过5M,不能进行上传.',
  VolumeExceeds20mAndCannotUploaded: '文件体积超过20M,不能进行上传.',
  PlaceOfDeliverySeaport: '交货地（海港）',
  PlaceOfDeliveryAirport: '交货地（空港）',
  SailingDay: '开航日',
  BusinessCreationDate: '业务创建日',
  DeliveryStation: '交货站',
  NoDocumentsDeclaringOrNonSpermWhaleUsers: '未查询到单证，可能正在申报或非抹香鲸用户.',
  HasContainerNoOrSealNoForSameEqTypeAndEqSize: '此箱型已关联箱封信息，是否同步更改装箱信息页签箱型箱种？',
  SeaEqAsyncToContainerTip: '已输入相关箱封信息，请先删除装箱信息页签箱封信息！',
  TheSynchronizedFileCannotBeEdited: '被同步的文件不可编辑',
  TheSynchronizedFileIsNotDeleted: '被同步的文件不可删除',
  CurrentBusinessStatusCannotBeSynchronized: '当前业务状态不可同步',
  TheSynchronizedExpensesCannotBeDeleted: '已同步费用无法删除，请先取费用用同步。',
  ChargeSyncConfirmTip: '当前费用同步操作不可逆，是否确认继续？',
  ChargeAlreadySynced: '费用已同步，不能再次同步',
  CurrentlyThereIsNoSynchronizationCosts: '当前无可同步费用',
  ThereAreCurrentlyNoCancellableCharges: '当前无可取消费用',
  NoCurrentChargesCanBeCancelled: '当前无可取消同步费用',
  ChargeItemChangeTip: '此费用名称默认结算信息与当前费用不一致，是否更新？',
  SubscriptionInformation: '设置您要接收订阅信息的（分）公司',
  SetUpThePartners: '设置您需要订阅的合作伙伴',
  PleaseSelectAInformation: '请选择一条运价信息.',
  ThisRateHasExpired: '此运价已过期!',
  ExternalUsersCannotEdit: '外部用户不能编辑,请至合作伙伴电商用户页签.',
  CommunicationConfirmation: '运价有效期内找不到符合船期要求的开航日期,请与订舱方沟通确认!',
  CombineTips: '不能选择主票进行组合！',
  RepeatMblForSave: '主单号重复，是否确认保存？',
  SystemAlert: '系统提醒',
  NotRepeatOperation: '状态已变更，请勿重复操作。',
  FeesHaveBeenUsedForEditUnit: '已有费用使用到该单位代码，不能修改！',
  TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit: '已有费用方案使用到该计费单位代码，不能修改！',
  ApplyChangeChargeNotThrough: '已{0}, 不能{1}, 请重新勾选。',
  KingdeeNotExist: '数据无需同步或金蝶系统不存在',
  ByAdjustmentDate: '按调整日期',
  ByBusinessDate: '按业务日期',
  PleaseEnterTheFileType: '请输入文件类型',
  NotExportToImportBusiness: '此单不是出口转进口业务，不能同步！',
  JobNotOperateStatus: '此单不是正操作状态，不能同步！',
  JobShutOut: '此单已退关，不能同步！',
  ChargeSyncSuccess: '费用同步成功！',
  NoSynchronizedFees: '没有可同步的费用！',
  SaveColumnSettingsSameTime: '同时保存当前显示列设置',
  SaveScheme: '保存方案',
  ReceivableCharge: '应收(费用)',
  PayableCharge: '应付(费用)',
  TruckingNotExist: '做箱信息不存在！',
  SaveDisplayColumns: '保存显示列',
  NoPermissionToAddExpense: '没有费用新增权限',
  NoPayableAddPermissionCannotImported: '您没有应付费用新增权限，无可导入费用',
  NoPayableAddPermissionOnlyImportReceivable: '您没有应付费用新增权限，仅导入应收费用',
  NoReceivableAddPermissionCannotImported: '您没有应收费用新增权限，无可导入费用',
  NoReceivableAddPermissionOnlyImportPayable: '您没有应收费用新增权限，仅导入应付费用',
  OnlyRejectedBusinessesCanDelete: '只能删除已拒绝的业务',
  OnlyRejectedBusinessesCanDeleteIgnoreOther: '只能删除已拒绝的业务，其他业务已忽略',
  SuccessfullySubmittedXBusiness: '已成功提交 {num} 条业务',
  SuccessfullySubmittedXBusinessOtherIgnore: '已成功提交 {num} 条业务，其余业务预审状态不满足提交条件',
  SuccessfullyRevokedXBusiness: '已成功撤回 {num} 条业务',
  SuccessfullyRevokedXBusinessOtherIgnore: '已成功撤回 {num} 条业务，其余业务预审状态不满足撤回条件',
  SuccessfullyConvertRealXBusiness: '已成功转正式业务 {num} 条',
  SuccessfullyConvertRealXBusinessOtherIgnore: '已成功转正式业务 {num} 条，其余业务预审状态不满足转正式业务条件',
  ChargeSyncJobStateCheckFail: '费用同步业务状态校验不通过',
  HaveChargeNotAllocatedAndtoContinue: '有费用未做分摊，请确认是否继续费用同步？',
  PartnerAlreadyExistPleaseSelectOfficialCustomer: '合作伙伴已存在，请在正式客户里选择',
  PartnerHasMaintainedUndeToContinue: '在【{officeCode}】下已维护此合作伙伴，是否继续创建？',
  fileManagement: '文件管理',
  FilterValue: '过滤值',
  PriceAndNumIsNull: '单价、数量为空，是否继续？',
  SyncContainerSealNoToBillOfLading: '同步更新提单装箱信息箱封号',
  AssociatedBillOfLadingCannotDelete: '已关联提单，不可删除',
  AssociatedBillOfLadingCannotRemove: '已关联提单，不可移除',
  SettlementObjectAccountPeriod: '结算对象账期',
  SettlementObjectAccountCredit: '结算对象信控额度',
  InvoiceHeaderDifferent: '开票抬头不一致，是否继续？',
  Agreement: '一致',
  NotAgreement: '不一致',
  AllocationNature: '分摊性质',
  VirtualAllocation: '虚拟分摊',
  ActualSplit: '真实拆分',
  ShareTypeTip: '一致：所有费用的分摊类型全部一致，修改一条费用的分摊类型，其他的费用则全部更改为一致\n不一致：费用的分摊类型可以不一致，更改分摊类型时只更改当前费用的分摊类型',
  VirtualAllocationAndActualSplitTip: '虚拟分摊：在主单进行做账单、开票、付款申请、销账等结算\n分摊到小票的费用是虚拟的，仅能查看，不进行实质性的结算。\n\n真实拆分：分摊后的费用在分单进行做账单、开票、付款申请、销账等结算\n如主单的费用已经结算则不能拆分费用到小票',
  ActualSplitWarn: '注意：真实拆分后，不保留主单的原费用且无法还原，请谨慎操作！',
  CannotActualSplitTip: '主单的费用建账单、开票，付款申请、销账等结算动作后不能拆分费用到小票！',
  SharedChargeTotal: '分摊费用总金额',
  DataHadUpdated: '数据已被修改，请重新查询后再试',
  OpenSOPPanelNeedDoubleClick: '如需开启SOP面板，可双击业务状态再次唤起。',
  Operator: '操作人员',
  HaveInHand: '进行中',
  Exception: '异常',
  TerminalCompany: '码头公司',
  TerminalLocation: '码头公司',
  DeliveryAddress: '提货地址',
  TerminalAddress: '提货地址',
  TcDeliveryAddress: '码头公司提货地址信息',
  ResultLogUploadFaild: '结果日志上传云存储失败，请重试！',
  ConfigureDisplayColumns: '配置显示列',
  AllNames: '所有名',
  SelectedColumns: '已选列',
  NoPermissionViewSecondaryTable: '你没有权限查看二级表信息！',
  NoPermissionSetSecondaryTableColumns: '你没有权限设置二级表显示列！',
  UpdateNoticeDetails: '更新通知【详细内容】',
  DontRemindMeAgain: '下次不再提醒',
  NewInnerContractNo: '新建内部约号',
  EditInnerContractNo: '内部约号修改',
  AreYouSureToCancelThisData: '确认撤销该条数据？',
  HasBeenUsedAndCannotEditContractNo: '已被使用，无法编辑约号',
  HasBeenUsedAndCannotBeDeleted: '已被使用，无法删除',
  ApplicableRoute: '适用航线',
  IsEnable: '是否启用',
  ContractNoUseState: '约号使用状态',
  NotUse: '未使用',
  Occupies: '占',
  DataLoadingFailed: '数据加载失败。。。',
  ExportExcel: '导出Excel',
  ExportExcel2: '导出EXCEL',
  ExportPDF: '导出PDF',
  ExportWord: '导出WORD',
  ExportPPT: '导出PPT',
  NoDataIsCurrentlySelected: '当前未选中数据',
  SelectAll: '全选',
  CustomerSelfIssue: '客户自出单',
  Clear: '清除',
  QuickOfLadingNumberCustomsNumber: '快捷检索:业务编号/提单号/关单号',
  QuickMnemonicabbreviationChineseAndEnglishNames: '快捷检索:助记码/简称/中英名',
  InvoiceNumber: '/发票号',
  BusinessNumber: '/业务编号',
  BillingNumber: '/账单号',
  PaymentApplicationNumber: '/付款申请号',
  VerificationNumber: '/核销编号',
  ReconciliationNumber: '/对账单号',
  ActualPaymentAndReceiptNumber: '/实收付编号',
  DeliveryOrderNumber: '/放单号',
  ProgramNumber: '/方案编号',
  QuickSearch: '快捷检索',
  SearchBeRemovedNotFound: '未找到需要剔除的searchItem',
  Error3: '错误',
  AdvancedSchemeLoadingFailed01: '高级查询配置方案加载失败01=：',
  TheFoundPleaseSelectScheme: '未找到该方案，请选择其他方案',
  AreYouWantToDelete: '确定要删除吗?',
  Tip: '提示',
  DeleteSchemeFailed: '删除方案失败:',
  N1Exceeds4MBCannotUploaded: '1个文件体积超过4MB,不能进行上传.',
  N1Exceeds20MBCannotUploaded: '1个文件体积超过20MB,不能进行上传.',
  DeleteFileFailed: '删除文件失败！',
  Edit: '编辑',
  SelectFile: '选择文件',
  DeleteFile: '删除文件',
  Upload: '上传',
  UploadFile: '上传文件',
  FileName: '文件名',
  FileType: '文件类型',
  FileSize: '文件大小',
  Uploader: '上传人',
  UploadTime: '上传时间',
  UploadProgress: '上传进度',
  Uploading2: '上传中...',
  WaitingForUpload: '等待上传',
  DocumentCategory: '文档类别',
  PlatformCustomerService: '平台客服',
  Yes: '是',
  No: '否',
  Confirm: '确认',
  SaveColumnStatus: '保存列状态',
  ResetColumnStatus: '重置列状态',
  SaveColumnStatusSuccess: '保存列状态成功',
  SaveColumnStatusFailed: '保存列状态失败',
  ResetColumnStatusSuccess: '重置列状态成功',
  ChatWindow: '聊天窗口',
  Internal: '内部',
  Communication: '沟通',
  InternalCommunication: '内部沟通',
  ExternalCommunication: '外部沟通',
  Customer: '客户',
  Reset: '重置',
  Search: '查找',
  CurrentlySelectedItem: '当前选中项:',
  Port: '港口',
  State: '州',
  FileAbnormalCannotBeUploaded: '文件体积异常,不能进行上传.',
  File20MCannotBeUploaded: '文件体积超过20M,不能进行上传.',
  UploadSuccessful: '上传成功',
  ImportFile: '导入文件',
  PrintTemplate: '打印模板：',
  Code: '代码',
  ChineseName: '中文名',
  EnglishName: '英文名',
  Country: '国家',
  Region: '区域',
  Name2: '姓名',
  StartDate: '开始日期',
  To: '至',
  EndDate: '结束日期',
  CurrentAuthorizations: '当前拥有的授权',
  Refresh: '刷新',
  User: '用户：',
  Authorization: '授权',
  Time: '时间：',
  AuthorizationUseHistory: '授权使用历史：',
  AuthorizationFailed: '授权失败',
  SendTest: '发送测试',
  CurrentPersonalAuthorizationList: '当前个人授权列表',
  SendTo: '发送至：',
  Confirm2: '确定',
  Cancel: '取消',
  Close: '关闭',
  Open: '开启',
  AuthorizationItemDescription: '授权项说明',
  AuthorizationItem: '授权项',
  AuthorizationStatus: '授权状态',
  NotSet: '未设置',
  StatusChangeTime: '状态变更时间',
  Operation: '操作',
  PleaseAddProductDescriptionHere: '请在这里添加产品描述',
  WeChatMessagePush: '微信消息推送',
  MarqueeSwitch: '跑马灯开关',
  PleaseInEmailPasswordauthorizationCode: '请填写邮箱密码/授权码！',
  PleaseFillInRecipientEmail: '请填写收件邮箱！',
  EmailSettingsTestEmail: '邮箱设置-测试邮件',
  SendSuccessfully: '发送成功',
  PaymentUponReceipt: '见款放单',
  All: '全部',
  Unread: '未读',
  Read: '已读',
  MMDDDayHHMm: 'MM月DD日 HH:mm',
  AssignSales: '分配销售',
  ReleaseSales: '释放销售',
  ReviewSales: '审核销售',
  SuccessfullyGrabCustomer: '抢客户成功',
  GrabCustomerFailed: '抢客户失败',
  ScheduleReminder: '日程提醒',
  CustomerExpirationReminder: '客户到期提醒',
  BusinessReviewReminder: '业务审核提醒',
  CustomsDeclarationReminder: '报关提醒',
  AbnormalHandlingOfBox: '箱子异常处理',
  DeparturePickUpContainerWarning: '出发提柜预警',
  BoxArrivingAtFactoryWarning: '箱子到厂预警',
  BoxLeavingFactoryWarning: '箱子离厂预警',
  CustomsReleaseWarning: '海关放行预警',
  TerminalReleaseWarning: '码头放行预警',
  BoardingWarning: '上船预警',
  DepartureWarning: '离港预警',
  ArrivalWarning: '到港预警',
  ReturningBoxWarning: '还箱预警',
  SystemArrearsReminder: '系统欠费提醒',
  ChangeReviewAndApprovalReminder: '更改费用审核审批提醒',
  DefaultMessage: '默认消息',
  Message: '系统消息',
  SelectTemplate: '选择模板',
  PleaseSelectTheExportTemplate: '请选择导出模板',
  Upload0UploadFailure0: '上传成功:{0}个,上传失败:{1}个.',
  SuccessfulFailure0ConfirmSave: '成功上传:{0}个,失败:{1}个，确认要保存吗？',
  Only0FormatCanUploaded: '只能上传格式为{0}的文件',
  YouToOpenTheModule: '你没有打开【{0}】模块的权限',
  Upload0UploadFailed0: '上传成功:{0}个,上传失败:{1}个.',
  All2: '(全部)',
  NumberOfPiecescommissionactual: '件数(委/实)',
  LetterOfCreditTerms: '信用证条款',
  N4InsuranceCompletion: '4投保完成',
  N2Inquiry: '2询价',
  SensitiveWords: '条敏感词',
  FreightRateDetails: '运价详情',
  Manufacturer: '制造商',
  ShipName: '船名：',
  IsItCorrect: '是否正确。',
  BoxReturnedFromTheArea: '港区返回的箱货信息：',
  CurrentlyStatusAndCannotDeleted: '当前正处于编辑状态，不可删除',
  ChineseAbbreviationOfTheCompany: '公司中文简称:',
  TheTheCompanyCannotEmpty: '公司英文简称不能为空',
  Voyage: '航程:',
  ShippingSchedule: '船期: ',
  PortOfDepartureUpdate: '起运港更新',
  DestinationPortUpdate: '目的港更新',
  ChatInside: '内部沟通',
  ChatByClient: '外部沟通',
  DoubleClickToSelectState: '双击文本框选择状态查询',
  StateQuery: '状态查询',
  EdiStateQuery: 'EDI状态查询',
  BookingEdiSendType: '订舱EDI通道',
  BookingEdiSendTime: '订舱EDI时间',
  imConnecting: '正在努力连接中.....',
  imConnectFailed: '会话连接失败，请关闭后重新打开。',
  SwitchBranchAndOpenModuleTipAllEdit: '请在切换分公司前保存数据并关闭已打开的模块,目前打开{0}个模块，是否关闭全部模块？',
  SwitchBranchAndOpenModuleTipNotEdit: '请在切换分公司前关闭已经打开的模块,目前打开{0}个模块，是否全部关闭？',
  SwitchBranchAndOpenModuleTipPartEdit: '请在切换分公司前保存数据和关闭模块,目前打开{0}个模块未保存和关闭，是否全部关闭？',
  PrintRecordsOverLimitTip: '打印记录数超过系统上限，是否直接导出？',
  PrintRecordsOver100Tip: '打印记录数超过100条，加载时间可能较长，是否直接导出？',
  ContinuePreview: '继续预览',
  NotSupported: '暂不支持 {0} 多程数据拼接显示',
  PleaseFillInCorrectly: '请正确填写多程信息，不允许中间有空的',
  DoNotEmpty: '一程数据不许清空',
  AirlineReplacement: '一程航司发生了变更，将清空起运港机场信息(机场、实际进场时间、实际配载时间、预计起飞时间、实际起飞时间)并重新获取数据',
  AirlineReplacement1: '1.修改后的航司未在支持订阅的航司列表中，将无法获取数据',
  AirlineReplacement2: '2.一程航司发生了变更，将清空起运港机场信息(机场、实际进场时间、实际配载时间、预计起飞时间、实际起飞时间)',
  AirlineReplacementLast: '最后一程航司发生了变更，将清空目的港机场信息(预计达时间，实际抵达时间、实际收单时间、实际卸货时间、实际到货通知时间、实际提货时间)并重新获取数据',
  AirlineReplacementLast2: '2.最后一程航司发生了变更，将清空目的港机场信息(预计抵达时间、实际抵达时间、实际收单时间、实际卸货时间、实际到货通知时间、实际提货时间)',
  ViewShippingTracking: '若是存在多程不同航司，数据请查看【航运追踪】页签',
  IntermediateAirline: '修改后的航司未在支持订阅的航司列表中，将无法获取二程数据',
  ExportingPleaseWait: '正在导出文件，请稍等',
  PrintTaskProcessing: '正在生成打印文件...',
  PrintTaskProcessingProgress: '正在生成打印文件（{0}/{1}）...',
  PrintTaskDownloading: '生成完成，正在下载文件...',
  PrintTaskUnknownUnit: '打印单元',
  PrintTaskFailed: '打印任务失败：{0}',
  ExportTakePlaceInBackground: '你可以离开页面，导出将在后台进行',
  CompletionDownloadMessageReminderInRightCorner: '完成后请到右上角 "消息提醒" {0} 中下载。',
  FileExportCompletionReminder: '文件导出完成提醒',
  SyncPartnerToFinanceCodeReminder: '客商编码导入完成提醒',
  NoNewPermissionsForFees: '没有费用新增权限',
  NoPayChargesImport: '您没有应收费用新增权限，无可导入费用',
  NoCostChargesImport: '您没有应付费用新增权限，无可导入费用',
  OnlyCostChargesImport: '您没有应收费用新增权限，仅导入应付费用',
  OnlyPayChargesImport: '您没有应付费用新增权限，仅导入应收费用',
  ConfirmDeleteN: '确认删除这{0}条记录吗？',
  AffiliatedBranchStyle: '所属分公司样式',
  DisplayByOrganizationalStructure: '按组织架构显示',
  AllDisplay: '全部显示',
  FileView: '文件查看',
  NotPermissionToEditFilesByOtherUsers: '权限不足：无权编辑其他用户上传的文件',
  NotMatchingTheCostOfTheProjectCanBeDelete: '没有匹配的费用项目可删除.',
  ThisPartnerDoesNotSupportEnterReceivableFees: '此合作伙伴不支持录入应收费用',
  ThisPartnerDoesNotSupportEnterPayableFees: '此合作伙伴不支持录入应付费用',
  Can_Changed: '可改单',
  Customer_Service: '客服部门',
  Documentation_Department: '单证部门',
  Countries_Regions_Destination: '目的港国家/地区',
  CargoDocAndContainerQWTNotSame: '提单装箱信息与业务装箱信息不一致！',
  Some_Items_Have_Expired: '部分费用收费项目已失效，抄录失败',
  SentDestinationPortAgentTip: '时间已通过一键发送功能发送过目的港邮件',
  SendFileVerification: '发送文件校验',
  SendFileVerificationSuccessTip: '文件验证成功，请点击【下一步】继续发送邮件，或【取消】',
  SendFileVerificationExceptionTip: '文件验证异常，请点击【下一步】继续发送邮件，或【取消】',
  Validating: '验证状态',
  MasterCheckExist: '主票验证：{0} 是否存在',
  SmallCheckExist: '小票验证：{0} 是否存在',
  EmailAttachments: '邮件附件',
  DeleteAttachTip: '确定要删除这个附件吗?',
  LocalEmailSentSuccess: '本地邮箱发送成功？',
  LocalEmailTooLarge: '邮件内容太大，无法跳转本地邮箱！',
  Lack: '缺少',
  FileDragArea: '将文件拖拽到此区域上传',
  EnterKeyword: '输入关键字',
  ClearSelectedItems: '清空所选项',
  ManifestFileNumBox: 'MANIFEST文件数等于箱量',
  ManifestFileNumNotEqualBox: '【箱量】: {0} /【MAINFIEST】文件数：{1} ，MANIFEST文件和箱量不一致',
  TheSelectedDataIsIgnoredSuccessfully: '已选数据忽略成功',
  SelectedDataHasBeenBatchProcessedSuccessfully: '已选数据取消忽略成功',
  ThereAreNoNegligibleCosts: '没有可忽略的费用',
  ThereAreNoFeesThatCanBeEliminated: '没有可取消忽略的费用',
  OnlyUnRead: '只看未读',
  AllMarksRead: '全部标记已读',
  MessageConfig: '消息设置',
  SaleProductCodeCannotBeNull: '可售卖产品不能为空',
  FullOrInsideCannotBeNull: '全程/国内不能为空',
  NotNullForMapping: '基本页签"【可售卖产品】和【全程/国内】字段不能为空"，请输入后再选择费用',
  DifferentJobOrBusinessFieldValues: '所选业务中包含多个不同岗位或业务字段值，不设置时，将保留原有岗位和字段值',
  PreserveOriginalValue: '保留原',
  SelectSynchronizedFields: '选择同步字段',
  SynchronizedFields: '同步字段',
  RunSuccess: '运行成功',
  RunFail: '运行失败',
  PleaseUpload: '原始值为空，请上传文件',
  CodeTip: '1、此处代码语言：javascript' +
      '\n2、默认的原始待处理对象名称为：result. (result的全部内容就是原始值的JSON对象)' +
      '\n3、要获得第一个元素，可以使用： result[0]. (元素从第0个开始计数)' +
      '\n4、要获得某个识别字段的值，可以使用：result[0].text.data[\'包装\']' +
      '\n5、要修改包装的值，可以使用：result[0].text.data[\'包装\'] =\'PPK\'' +
      '\n6、要替换包装中全部的"P"的值，可以使用：result[0].text.data[\'包装\'] =result[0].text.data[\'包装\'].replaceAll(\'P\',\'B\');',
  BlIsIssued: '提单已经签发',
  NoVirtualHBLTip: '本业务没有形式分单，请先勾选形式分单后进行操作',
  NoVirtualHBLAuthTip: '没有本页签权限，请联系管理员配置形式分单权限后使用！',
  FieldValueCannotBeNull: '{0}不能为空',
  ImportFailedFileNameNotMatch: '导入失败，文件名称不是ISF5或ISF10开头',
  ISF5File: 'ISF5模版',
  ISF10File: 'ISF10模版',
  BookingLabel: '订舱页签',
  BatchPurchasePriceLock: '请勾选买价未锁定的业务进行操作。',
  BatchPurchasePriceUnLock: '请勾选买价已锁定的业务进行操作。',
  BatchSellingPriceUnLock: '请勾选卖价已锁定的业务进行操作。',
  BatchSellingPriceLock: '请勾选卖价未锁定的业务进行操作。',
  NotPermissionToViewFiles: '存在无权限查看的文件{0}，不可对其发送邮件',
  ContainerTotalNeedEqual: '集装箱【外包装件数】【内包装件数】【毛重】【净重】合计数需要与特殊货物编号内总数一致',
  PackingAddNotRepeat: '选择的装箱信息已添加，请勿重复添加',
  vesselNotFound: '船名不允许直接录入，请检查后重新输入',
  exportToImportNotUpdatedVessel: '出口转进口，订舱页签不允许修改船名',
  voyageNotFound: '航次不允许直接录入，请检查后重新输入！',
  exportToImportNotUpdatedVoyage: '出口转进口，订舱页签不允许修改航次',
  smallReceiptNotVoyage: '主票下的小票不允许编辑航班',
  mblOnlyNotFreightTermHBL: '不是直单，不能修改分单运输条款！',
  notUpdateFreightTermHbl: '出口转进口业务不能更新分单运输条款',
  otherButtonNotUpdate: '其他按钮没有勾选，无法修改',
  notUpdateDischargingPortDoor: '未勾选目的港服务，无法勾选目的港派车！',
  notUpdateDispatchingPlaceCode: '该单据为主票，没有发货地(代码)字段无法修改！',
  notUpdatePacking: '出口转进口业务不能更新包装字段',
  notUpdateDispatchingPlaceExport: '出口转进口业务不能更新发货地字段',
  notUpdateDispatchingPlace: '该单据为主票，没有提单发货地字段无法修改！',
  notUpdateOther: '该单据为主票，没有其他段无法修改！',
  notUpdateCustomsDeclarationType: '报关没有勾选，报关类型字段无法修改！',
  haveChargeNotUpdateCustomsDeclarationType: '存在费用，报关类型字段无法修改！',
  packingRequired: '包装字段是必填项，不能为空！',
  freightTermHBLRequired: '分单运输条款字段是必填项，不能为空！',
  seBookingTermRequired: '约价性质字段是必填项，不能为空！',
  aeBookingTermRequired: '订舱性质字段是必填项，不能为空！',
  noUpdateCustomClaim2: '报关方式不是委托报关，不能修改报关类型！',
  transportLineRequired: '航线字段是必填项，不能为空！',
  noUpdateSmallTicketTransportLine: '有主票的小票不能修改航线字段！',
  departureStationRequired: '始发站字段是必填项，不能为空！',
  noUpdateSmallTicketDepartureStation: '有主票的小票不能修改始发站字段！',
  destinationStationRequired: '目的站字段是必填项，不能为空！',
  noUpdateSmallTicketDestinationStation: '有主票的小票不能修改目的站字段！',
  noUpdateSmallTicketForwardingAgent: '有主票的小票不能修改发运代理字段！',
  businessLock: '业务被锁定，不能修改',
  businessNotEmpty: '提单号不能为空',
  businessNotUpdate: '提单不满足修改条件',
  notOperateNotUpdateQuantity: '没有操作权限，则不能编辑提单数量',
  notOperateNotUpdateWeight: '没有操作权限，则不能编辑毛重',
  notOperateNotUpdateCubage: '没有操作权限，则不能编辑体积',
  notOperateNotUpdatePackingName: '没有操作权限，则不能编辑包装显示名',
  notOperateNotUpdatePaymentPlaceBL: '不能编辑该提单HBL付款地点字段',
  notOperateNotUpdateRequestReleaseState: '不能编辑该提单申请放单状态字段',
  notOperateNotUpdateFreightTermHBL: '不能编辑该提单运输条款字段',
  notOperateNotUpdateSoNo: '不能编辑该提单SO NO.字段',
  notOperateNotUpdateLoadingPortCode: '不能编辑该提单：提单起运港字段',
  notOperateNotUpdateDischargingPortCode: '不能编辑该提单：提单卸货港字段',
  notOperateNotUpdateVesselVoyage: '不能编辑该提单：船名航次字段',
  notOperateNotUpdateDestinationPortCode: '不能编辑该提单：提单交货地字段',
  notOperateNotUpdateReleaseDate: '不能编辑该提单：放单日期字段',
  notOperateNotUpdateWithHoldDate: '不能编辑该提单：扣单日期字段',
  notOperateNotUpdateSurrenderedNo: '不能编辑该提单：放单号字段',
  notOperateNotUpdateWithHoldReason: '不能编辑该提单：扣单原因字段',
  selectRequirement: '双击选择操作要求',
  DataGroup: '数据分组',
  CloseRefreshNeedMannulUpdate: '关闭自动刷新时，需要人为点击【刷新】进行数据更新！',
  RefreshRule: '刷新规则：',
  NodeRecord: '节点记录：',
  HomePageNotRefreshData: '进入首页时不自动刷新数据',
  DisplayLastClickNode: '显示最后一次点击的节点',
  RetainQueryCondition: '并保留该节点的查询条件',
  N0VerificationPassed: '【{0}】验证通过',
  ConsigneeCompanyName: '收货人企业名',
  TaskBoard: '任务看板：',
  AlertNode: '预警节点：',
  DoOfQueryResultsTemplates: '不根据查询结果数量显示，切换模板时重置查询条件',
  SendPortAgentByNumber: '发送目的港代理-按箱号',
  SendAgentByCaseNumber: '发送套单代理-按箱号',
  SetOrderAgency: '套单代理',
  LastSentTime: '上次发送时间',
  ShippingCompanyCannotBeModifiedBylclMasterUuid: '拼箱主单不为空船公司不允许修改',
  ShippingCompanyCannotBeModifiedByCharge: '船公司存在费用不允许修改',
  ShippingCompanyNotExist: '船公司不存在',
  AirCompanyCannotBeModifiedBylclMasterUuid: '拼箱主单不为空航空公司不允许修改',
  AirCompanyCannotBeModifiedByCharge: '航空公司存在费用不允许修改',
  AirCompanyNotExist: '航空公司不存在',
  SeToSiCannotBeUpdatedToShippingCompany: '跨租户出口转进口业务不允许修改船公司',
  TheDesignatedFreightForwarderCannotBeModified: '该业务的指定货代理不可修改',
  TheValueOfTheDesignatedFreightForwarderIsIncorrect: '该业务指定货代理的值有误或已被禁用',
  BusinessOperationsCannotBeModified: '存在舱位关联了“已审核”“已提交”“预提交”“提交中”的业务，不可通过批量转船修改。需各自单独修信息。',
  UpdateVoyageInfoMessage: '更新航次信息，将同时更新海运出口业务中的航次相关信息,确认更新后将发送邮件通知：',
  updateBatchTips: '更新航次信息，将同时更新海运出口业务中的航次相关信息，是否确认？',
  batchUpdateShipSuccess: '批量转船成功',
  CustomPageSettings: '自定义页面设置',
  EnterCustomPageSettings: '进入自定义页面设置',
  Russian: '俄语',
  Vietnamese: '越南语',
  Thai: '泰语',
  SelectTransshipmentStatusErrorPrompt: '仅支持批量修改正操作业务',
  PleaseSelectTheMainTicketForModification: '请选择主票进行修改',
  NoAccessPermission: '无访问权限'
}
